const it = {
  "header.customerService": "Servizio clienti",
  "header.freeShipping": "Spedizione gratuita da {n} €",
  "header.login": "Accedi",
  "header.admin": "Administration",
  "header.myAccount": "Il mio conto",
  "header.myWishlist": "La mia lista dei desideri",
  "header.myOrders": "I miei ordini",
  "header.logout": "Disconnettersi",
  "header.parts": "Ricambi auto",
  "header.wholeCategory": "Tutta la categoria {name} →",
  "header.brands": "Marche",
  "header.guides": "Guide",
  "header.topGuides": "Le guide più lette",
  "header.allGuides": "Tutte le guide e i consigli",
  "header.allBrandsAZ": "Tutte le marche dalla A alla Z ({count})",
  "header.removeVehicle": "Rimuovere il veicolo",
  "header.createAccount": "Creare un account",
  "header.brandsAZ": "Marche dalla A alla Z",
  "header.contact": "Contact",
  "header.language": "Lingua",
  "header.searchPlaceholder": "Cercare un ricambio, una marca o un riferimento",
  "header.searching": "Ricerca in corso...",
  "header.noResults": "Aucun résultat pour \"{term}\"",
  "header.openProduct": "Aprire la pagina prodotto",
  "header.matchesRef": "Corrisponde alla rif. {kind}",
  "footer.tagline": "6,7 milioni di ricambi auto in un unico posto",
  "footer.contactUs": "Contattaci",
  "footer.contact": "Contact",
  "footer.shipping": "Spedizione e tracciamento",
  "footer.returns": "Garanzia e resi",
  "footer.about": "Chi siamo",
  "footer.sitemap": "Mappa del sito",
  "footer.budget": "Budget manutenzione per modello",
  "cookies.title": "Cookie e statistiche",
  "cookies.text": "Utilizziamo cookie necessari al funzionamento del sito (carrello, accesso) e, con il Suo consenso, cookie statistici (Google Analytics, PostHog) per migliorare OTOPIECES.COM. Nessuna pubblicità. La Sua scelta è conservata 6 mesi.",
  "cookies.accept": "Accetta tutto",
  "cookies.refuse": "Rifiuta",
  "cookies.customise": "Personalizza",
  "cookies.save": "Salva le mie scelte",
  "cookies.necessary": "Cookie necessari",
  "cookies.necessaryHint": "sempre attivi (carrello, sessione, preferenze)",
  "cookies.analytics": "Statistiche",
  "cookies.analyticsHint": "statistiche anonime di navigazione (Google Analytics, PostHog)",
  "cookies.close": "Chiudi",
  "cookies.manage": "Gestisci i cookie",
  "cookies.statusOn": "Statistiche: attivate. Può modificare la Sua scelta in qualsiasi momento.",
  "cookies.statusOff": "Statistiche: rifiutate. Vengono usati solo i cookie necessari.",
  "cookies.statusNone": "Non ha ancora scelto: sono attivi solo i cookie necessari.",
  "footer.securePayments": "Pagamenti sicuri:",
  "footer.fastShipping": "Consegna in tutta Europa",
  "footer.rights": "© 2026 OTOPIECES.COM. Tutti i diritti riservati.",
  "footer.trademarks": "Tutti i marchi sono di proprietà dei rispettivi titolari.",
  "common.ref": "Rif.",
  "common.addToCart": "Aggiungere al carrello",
  "common.free": "Gratuit",
  "common.subtotal": "Subtotale",
  "common.shipping": "Spedizione",
  "common.total": "Total",
  "common.vatIncluded": "IVA inclusa",
  "common.back": "Indietro",
  "common.continueShopping": "Continuare gli acquisti",
  "common.outOfStock": "Esaurito",
  "common.inStock": "Disponibile",
  "common.lowStock": "Solo {n} disponibili",
  "common.supplierStock": "Presso il nostro fornitore · entro {n} giorni",
  "common.compatible": "Compatible",
  "common.cancel": "Annulla",
  "common.apply": "Applica",
  "common.home": "Home",
  "common.breadcrumb": "Breadcrumb",
  "common.unit": "Unità",
  "common.perUnit": "/ unità",
  "common.discount": "Sconto ({code})",
  "common.packAvailable": "Disponibile come {label}",
  "common.equivalentOther": "Equivalente di un altro marchio (stesso rif. OEM)",
  "common.oem": "OEM ",
  "common.alternative": "alternative ",
  "common.bestPrice": "Miglior prezzo di mercato",
  "common.bestPriceTitle": "Prezzo confrontato con {n} concorrente/i{date}: OTOPIECES è il più economico.",
  "common.onDate": " il {date}",
  "stock.out": "Esaurito",
  "stock.supplier": { one: "Disponibile presso il nostro fornitore — spedito entro {n} giorno", other: "Disponibile presso il nostro fornitore — spedito entro {n} giorni" },
  "stock.low": "Solo {n} rimasti in stock",
  "stock.lowSupplier": " (+{s} chez notre fournisseur sous {lead} jours)",
  "stock.in": "Disponibile",
  "product.notFound": "Prodotto non trovato",
  "product.backHome": "Torna alla home",
  "product.allParts": "Tutti i ricambi {brand}",
  "product.manufacturerRef": "Rif. produttore:",
  "product.equivalentRef": "Riferimento equivalente",
  "product.oemRef": "Riferimento OEM del costruttore",
  "product.moreOem": { one: "+{n} altro rif. OEM", other: "+{n} altri rif. OEM" },
  "product.reviews": { one: "{n} recensione", other: "{n} recensioni" },
  "product.compatibleWith": "Compatibile con il Suo ",
  "product.notGuaranteed": "Non garantito per il Suo ",
  "product.ttcExclShipping": "IVA inclusa, spedizione esclusa",
  "product.tierBadge": "−{pct}% da {n}",
  "product.cheaperAlt": "Alternative dès €{price} chez {brand}",
  "product.cheaperAltCompat": "Alternativa compatibile da {price} € di {brand}",
  "product.soldBy": "Venduto da",
  "product.soldByDetail": "Vendu par lots de {n}{label} — €{total} {unitLabel}, soit €{unit} / unité",
  "product.theN": "par {n}",
  "product.totalFor": "Totale per {n} :",
  "product.insteadOf": "au lieu de €{price}",
  "product.outOfStockHint": "Temporaneamente esaurito",
  "product.photoCheck": "Verificare il mio pezzo da foto",
  "product.added": "Aggiunto al carrello",
  "product.addPack": "Aggiungi {qty}{label}",
  "product.viewCart": "Vedi carrello",
  "product.delivery": "Consegna 2-5 giorni",
  "product.deliverySub": "Gratuita da {n} €",
  "product.return": "Resi entro 14 giorni",
  "product.returnSub": "Soddisfatto o rimborsato",
  "product.warranty": "Garanzia 2 anni",
  "product.warrantySub": "Ricambi certificati",
  "product.description": "Description",
  'product.faqTitle': 'Domande frequenti su questo prodotto',
  'product.share': 'Condividi',
  'product.shareCopy': 'Copia link',
  'product.shareCopied': 'Link copiato',
  "product.specs": "Specifiche",
  "product.compatibleVehicles": "Veicoli compatibili",
  "product.universal": "Prodotto universale: compatibile con tutti i veicoli.",
  "product.allModels": "Tutti i modelli",
  "spec.manufacturer": "Produttore",
  "spec.reference": "Riferimento",
  "spec.otherRefs": "Altri riferimenti",
  "spec.oemRefs": "Riferimenti OEM",
  "spec.category": "Categoria",
  "product.alsoIn": "Anche in",
  "product.relatedSubs": "Altri ricambi {cat}",
  "product.relatedAll": "Tutta la categoria {cat}",
  "product.relatedMore": "Vedi tutte (+{n})",
  "product.relatedLess": "Vedi meno",
  "product.relatedVehicles": "Ricambi compatibili per veicolo",
  "product.guides": "Guide e consigli: {part}",
  "product.readGuide": "Leggi la guida",
  "cat.popularModels": "{part} per i modelli più richiesti",
  "spec.features": "Caratteristiche",
  "spec.ean": "Numero EAN",
  "spec.condition": "Condizione",
  "spec.new": "Nuovo",
  "spec.soldBy": "Venduto da",
  "spec.packagings": "Confezioni",
  "spec.avgRating": "Valutazione media",
  "spec.avgRatingValue": "{r} / 5 ({n} recensioni)",
  "spec.warranty": "Garanzia",
  "spec.warrantyValue": "2 anni minimo",
  "spec.availability": "Disponibilità",
  "pack.title": "Confezione",
  "pack.units": "{n} unités · €{price} / unité",
  "pack.unitPrice": "Prezzo unitario",
  "pack.insufficient": " · stock insufficiente",
  "tiers.title": "Tarifs dégressifs — achetez plus, payez moins",
  "tiers.quantity": "Quantità",
  "tiers.unitPrice": "Prezzo unitario",
  "tiers.saving": "Risparmio",
  "tiers.range": "{a} a {b}",
  "tiers.andMore": "{a} e oltre",
  "tiers.note": "Remise appliquée automatiquement dans le panier sur le prix unitaire.",
  "pro.ht": "soit €{price} HT",
  "pro.discount": "Prix pro −{pct}% : €{price} TTC dans le panier",
  "wishlist.added": "Aggiunto alla Sua lista dei desideri",
  "wishlist.removed": "Rimosso dalla Sua lista dei desideri",
  "wishlist.error": "Impossibile aggiornare la lista dei desideri",
  "wishlist.remove": "Rimuovere dalla lista dei desideri",
  "wishlist.add": "Aggiungere alla lista dei desideri",
  "wishlist.inList": "Nella mia lista",
  "wishlist.addToList": "Aggiungere alla mia lista",
  "faq.askPrompt": "Ha una domanda su questo ricambio? Ce la ponga, rispondiamo entro 24 h.",
  "faq.ask": "Fai una domanda",
  "faq.title": "Domande frequenti",
  "faq.seeAll": "Vedere tutte le domande ({n})",
  "faq.answerFrom": "Risposta di {author}",
  "tyre.howMany": "Quanti pneumatici?",
  "tyre.one": "1 pneumatico",
  "tyre.set4": "Set di 4 pneumatici",
  "tyre.n": "{n} pneumatici",
  "tyre.perTyre": "/ pneumatico",
  "tyre.insufficient": "Scorte insufficienti per un set di 4 — contattateci per il riassortimento.",
  "equiv.title": "Questo pezzo è disponibile anche presso altri marchi",
  "equiv.count": { one: "{n} alternative", other: "{n} alternatives" },
  "equiv.cheaper": { one: " · {n} più economico", other: " · {n} più economici" },
  "equiv.compare": "Confronta affiancati ({n})",
  "similar.title": "Prodotti simili",
  "similar.sub": "— {category} di altri marchi compatibili con gli stessi veicoli",
  "similar.subVehicle": "— compatibili con la Sua {vehicle}",
  "recent.title": "Visualizzati di recente",
  "recent.clear": "Cancella",
  "fitments.count": "{n} motorizzazione(i) · {b} marchio(i)",
  "fitments.filter": "Filtra (marchio, modello, motore)",
  "fitments.models": { one: "· {n} modello", other: "· {n} modelli" },
  "fitments.noMatch": "Nessuna motorizzazione corrisponde a \"{q}\".",
  "reviews.title": "Recensioni clienti",
  "reviews.outOf5": "su 5",
  "reviews.loginPrompt": "per recensire un prodotto che ha ordinato.",
  "reviews.login": "Accedete",
  "reviews.already": "Grazie, ha già recensito questo prodotto.",
  "reviews.rewardTitle": "Lasci una recensione e riceva il -{percent} % sul prossimo ordine",
  "reviews.rewardText": "Riservato ai clienti che hanno acquistato questo prodotto. Il suo codice personale le sarà inviato alla pubblicazione della recensione (valido {days} giorni).",
  "reviews.rewardLogin": "Accedi per lasciare una recensione",
  "reviews.rewardWrite": "Scrivi la mia recensione",
  "reviews.rewardAfterPurchase": "Disponibile dopo l'acquisto di questo prodotto.",
  "reviews.rewardThanks": "Grazie per la sua recensione! Ecco il suo codice -{percent} %",
  "reviews.rewardCopy": "Copia",
  "reviews.rewardCopied": "Codice copiato",
  "reviews.rewardValidity": "Da inserire nel carrello · valido fino al {date}, utilizzabile una sola volta.",
  "reviews.rewardUsed": "Codice già utilizzato — grazie!",
  "reviews.rewardMinOrder": "a partire da {amount} € di spesa",
  "reviews.customerPhotos": "Foto dei nostri clienti ({n})",
  "reviews.customerPhotosSee": "Vedi le recensioni",
  "reviews.customerPhotosHint": "Foto reali inviate da acquirenti verificati con la loro recensione. Clicca per ingrandire.",
  "reviews.yourRating": "La Sua valutazione *",
  "reviews.titleField": "Titolo",
  "reviews.titlePlaceholder": "Sintesi in poche parole",
  "reviews.comment": "Commento *",
  "reviews.commentPlaceholder": "Qualità, montaggio, rapporto qualità/prezzo...",
  "reviews.published": "La Sua recensione è stata pubblicata. Grazie!",
  "reviews.empty": "Nessuna recensione per il momento. Sia il primo a condividere la Sua esperienza!",
  "reviews.sortBy": "Ordina per",
  "reviews.merchantCollected": "Recensione raccolta dal commerciante",
  "reviews.verified": "Acquisto verificato",
  "reviews.replyFrom": "Risposta di {author}",
  "reviews.sort.recent": "Più recenti",
  "reviews.sort.helpful": "Più utili",
  "reviews.sort.photos": "Con foto prima",
  "reviews.share": "Condividi",
  "home.google.badge": { one: "su Google · {n} recensione", other: "su Google · {n} recensioni" },
  "brand.trust.title": "Indice di fiducia",
  "brand.trust.summary": { one: "{n} recensione verificata su {p} prodotto/i valutati", other: "{n} recensioni verificate su {p} prodotto/i valutati" },
  "brand.trust.recommended": { one: "{n} prodotto consigliato dai nostri clienti", other: "{n} prodotti consigliati dai nostri clienti" },
  "product.topBadge": "Consigliato dai nostri clienti",
  "product.topBadgeHint": "{r}/5 su {n} recensioni verificate",
  "reviews.translate": "Traduci",
  "reviews.translatedByAi": "Tradotto automaticamente",
  "reviews.originalShown": "Testo originale",
  "reviews.showOriginal": "Vedi l'originale",
  "reviews.showTranslation": "Vedi la traduzione",
  "reviews.translateError": "Traduzione non disponibile",
  "home.google.title": "Valutazione Google",
  "home.google.count": { one: "{n} recensione Google", other: "{n} recensioni Google" },
  "home.google.link": "Vedi tutte le recensioni su Google",
  "reviews.pendingNotice": "Grazie! La Sua recensione è stata ricevuta: sarà pubblicata dopo una breve verifica del nostro team.",
  "home.wall.kicker": "Recensioni verificate",
  "home.wall.title": "Gli automobilisti si fidano di noi",
  "home.wall.summary": { one: "su {n} recensione verificata", other: "su {n} recensioni verificate" },
  "reviews.shareText": "La mia recensione {stars} di {product}: «{comment}»",
  "reviews.shareMine": "Condividi la tua recensione con i tuoi amici:",
  "reviews.sort.best": "Valutazioni più alte",
  "reviews.sort.worst": "Valutazioni più basse",
  "questions.title": "Domande e risposte",
  "questions.ask": "Ponga una domanda",
  "questions.placeholder": "Ex. : Questa parte è compatibile con la versione station wagon? È necessario uno strumento specifico?",
  "questions.name": "Il Suo nome *",
  "questions.email": "La Sua e-mail * (per ricevere la risposta)",
  "questions.notice": "La Sua domanda sarà pubblicata con la nostra risposta. ",
  "questions.notifyEmail": "Riceverà una notifica via e-mail.",
  "questions.emailPrivate": "La Sua e-mail rimane privata.",
  "questions.empty": "Nessuna domanda ancora. Ha dubbi sulla compatibilità o sul montaggio? Ci contatti!",
  "questions.yours": "La Sua domanda",
  "questions.helped": "Questa risposta Le è stata utile?",
  "gallery.prev": "Foto precedente",
  "gallery.next": "Foto successiva",
  "cart.title": { one: "Il Suo carrello ({n} articolo)", other: "Il Suo carrello ({n} articoli)" },
  "cart.empty": "Il Suo carrello è vuoto",
  "cart.discover": "Scopra i nostri prodotti",
  "cart.units": "unità",
  "cart.soldBy": "Venduto da {n}",
  "cart.proPrice": "prezzo pro",
  "cart.quantity": "quantità",
  "cart.summary": "Riepilogo dell'ordine",
  "cart.promoLogin": "Ha un codice promo? Si autentichi per applicarlo.",
  "cart.freeShippingLeft": "Ancora {amount} € per la spedizione gratuita!",
  "cart.checkout": "Passa all'ordine",
  "cartDrawer.title": "Il mio carrello",
  "cartDrawer.saveLater": "Salva per dopo",
  "cartDrawer.fromWishlist": "Dalla tua lista dei desideri",
  "cartDrawer.goCart": "Vai al carrello",
  "cartDrawer.checkout": "Concludi l'ordine",
  "cart.loginToOrder": "Si autentichi per ordinare",
  "cart.guestNotice": "Il Suo carrello sarà mantenuto quando si autenticherà o creerà il Suo account.",
  "cart.freeShipping120": "Spedizione gratuita da {n} €",
  "cart.return14": "Resi entro 14 giorni",
  "cart.securePayment": "Pagamento 100% sicuro",
  "promo.placeholder": "Codice promo",
  "promo.invalid": "Codice non valido",
  "promo.remove": "Rimuovi codice",
  "savings.title": "Risparmia",
  "alt.cheaper": "Alternativa meno costosa di {brand}",
  "alt.perUnit": "−€{d} / unité",
  "alt.total": ", −€{s} € au total",
  "alt.replace": "Sostituisci",
  "alt.replaced": "{name} sostituito da {alt}",
  "alt.error": "Sostituzione non riuscita",
  "checkout.backToCart": "Torna al carrello",
  "checkout.stepShipping": "Spedizione",
  "checkout.stepPayment": "Pagamento",
  "checkout.stepConfirmation": "Confirmation",
  "checkout.shippingAddress": "Indirizzo di spedizione",
  "checkout.savedAddresses": "I miei indirizzi salvati",
  "checkout.address": "Indirizzo",
  "checkout.default": " · predefinito",
  "checkout.defaultBilling": " · fatturazione predefinita",
  "checkout.manageAddresses": "Gestire i miei indirizzi",
  "checkout.firstName": "Nome",
  "checkout.lastName": "Cognome",
  "checkout.email": "Email",
  "checkout.phone": "Telefono",
  "checkout.addressComplement": "Riga indirizzo 2",
  "checkout.complementPlaceholder": "Appartamento, piano, edificio...",
  "checkout.postalCode": "CAP",
  "checkout.city": "Città",
  "checkout.otherBilling": "Fatturare a un altro indirizzo",
  "checkout.invoiceFor": "· fattura intestata a {company}",
  "checkout.company": "Azienda (opzionale)",
  "checkout.vat": "Partita IVA UE (opzionale)",
  "checkout.continue": "Continuare al pagamento",
  "checkout.paymentMethod": "Metodo di pagamento",
  "checkout.autoPayNotice": "Consegna a {address} (indirizzo salvato).",
  "checkout.autoPayEdit": "Modifica indirizzo",
  "checkout.card": "Carta di credito",
  "checkout.cardInfo": "I dati della carta saranno richiesti alla conferma.",
  "checkout.ssl": "Pagamento sicuro SSL",
  "checkout.requested": { one: "{n} richiesto", other: "{n} richiesti" },
  "checkout.available": { one: "{n} disponibile", other: "{n} disponibili" },
  "checkout.fixCart": "Modifier mon panier",
  "checkout.country": "Paese di consegna", "checkout.carrier": "Modalità di consegna", "checkout.relay": "punto di ritiro", "checkout.errCountry": "Non consegniamo ancora in questo paese. Scegli un altro paese di consegna.", "cart.shippingEstimate": "Stima {country} · {carrier} — corriere e paese si scelgono nel passaggio successivo",
  "checkout.tyreFree": "Spedizione gratuita da 2 pneumatici", "checkout.relayPick": "Scegli il mio punto di ritiro", "checkout.relayChange": "Cambia punto di ritiro", "checkout.relayRequired": "Scegli un punto di ritiro Mondial Relay sulla mappa.", "checkout.relayTitle": "Scegli il tuo punto di ritiro",
  "checkout.weightTier": "tariffa a peso ({w} kg)",
  "checkout.processing": "Elaborazione...",
  "checkout.pay": "Payer €{amount}",
  "checkout.fastDelivery": "Consegna rapida",
  "checkout.fastDeliverySub": "2-5 giorni lavorativi",
  "checkout.securePayment": "Pagamento sicuro",
  "checkout.sslSub": "SSL 256-bit",
  "checkout.warranty": "Garanzia",
  "checkout.warrantySub": "Minimo 2 anni",
  "checkout.summary": "Riepilogo",
  "checkout.qty": "Qtà: {n}",
  "checkout.fitting": "Montaggio presso centro partner",
  "checkout.totalHT": "Totale IVA esclusa (conto pro)",
  "checkout.vatAmount": "· TVA €{amount}",
  "checkout.totalTTC": "Totale IVA inclusa",
  "checkout.useWallet": "Utiliser mon compte dépôt (€{amount} disponibles)",
  "checkout.walletUsed": "Compte dépôt utilisé",
  "checkout.toPay": "Residuo da pagare",
  "checkout.confirmed": "Ordine confermato!",
  "checkout.thanks": "Grazie per il Suo ordine. È stata inviata un'email di conferma a {email}",
  "checkout.orderNumber": "Numero ordine",
  "checkout.deliveryTo": "Consegna a",
  "checkout.viewOrders": "Visualizza i miei ordini",
  "checkout.errRequired": "Il campo \"{field}\" è obbligatorio",
  "checkout.errPostal": "Codice postale non valido (attesi 5 цифre)",
  "checkout.errEmail": "Indirizzo email non valido",
  "checkout.errPhone": "Numero di telefono non valido (es. 06 12 34 56 78)",
  "checkout.errBilling": "Indirizzo di fatturazione incompleto (nome o società, indirizzo, codice postale, città)",
  "checkout.errOrder": "Errore durante l'invio dell'ordine",
  "fitting.title": { one: "Montaggio del Suo {n} pneumatico", other: "Montaggio dei Suoi {n} pneumatici" },
  "fitting.intro": "Opzionale: faccia consegnare i Suoi pneumatici in un centro partner che li monterà ed equilibrerà. Scegli uno slot nel suo calendario oppure lasci che il centro La contatti.",
  "fitting.sorted": " I centri sono ordinati per affidabilità e poi per distanza da {place}.",
  "fitting.none": "Nessun montaggio — consegna all'indirizzo indicato",
  "fitting.recommended": "Consigliato",
  "fitting.distance": "a {km} km",
  "fitting.bestRated": "Migliore valutato vicino a Lei",
  "fitting.hideReviews": "Nascondi le recensioni",
  "fitting.showReviews": "Vedi le recensioni",
  "fitting.reliable": "Partner affidabile",
  "fitting.reliableTitle": "Centro che conferma rapidamente i propri appuntamenti",
  "fitting.online": "Slot online",
  "fitting.perTyre": "/ pneumatico",
  "fitting.hidden": { one: "{n} centro partner a oltre {km} km non è proposto.", other: "{n} centri partner a oltre {km} km non sono proposti." },
  "fitting.selected": "I Suoi pneumatici saranno spediti a {name} ({city}). Montaggio + equilibratura: {total} aggiunti all'ordine.",
  "slot.loading": "Caricamento degli slot…",
  "slot.unavailable": "Questo centro non ha ancora pubblicato i propri slot: La contatterà per fissare l'appuntamento dopo l'ordine.",
  "slot.choose": "Scelga il Suo slot presso {name}",
  "slot.centreProposes": "Il centro proporrà una data",
  "slot.info": { one: "Slot da {min} min, non prima di {d} giorno dopo l'ordine (tempi di consegna dei pneumatici). Il centro confermerà lo slot via e-mail.", other: "Slot da {min} min, non prima di {d} giorni dopo l'ordine (tempi di consegna dei pneumatici). Il centro confermerà lo slot via e-mail." },
  "slot.chosen": "Slot richiesto: {day} alle {time} — da confermare dal centro.",
  "home.h1": "Ricambi auto online al miglior prezzo — pezzi di ricambio per tutte le marche",
  "home.h1Sub": "Oltre 6.000 modelli referenziati: selezioni il Suo veicolo o inserisca la targa per trovare ricambi compatibili al 100 %. Grandi marche, consegna in 2-5 giorni, reso 14 giorni.",
  "home.seoTitle": "Ricambi auto economici online — Pezzi di ricambio per tutte le marche | OTOPIECES.COM",
  "home.seoDesc": "Ricambi auto al miglior prezzo su OTOPIECES.COM: freni, filtri, motore, pneumatici… Ricerca per veicolo o targa, consegna in 2-5 giorni, reso entro 14 giorni.",
  "home.seoKeywords": "ricambi auto, pezzi di ricambio, ricambi auto economici, ricambi online, ricerca per targa, pastiglie freno, filtro olio, pneumatici",
  "home.faqTitle": "Domande frequenti sull'acquisto di ricambi auto online",
  "home.faq1q": "Come posso essere sicuro che un ricambio sia compatibile con la mia auto?",
  "home.faq1a": "Selezioni il Suo veicolo (marca, modello, anno, motore) o inserisca la targa: il catalogo mostra solo i ricambi compatibili, con il badge «Compatibile con il Suo veicolo» su ogni scheda prodotto.",
  "home.faq2q": "Quali sono i tempi e i costi di consegna?",
  "home.faq2a": "Gli ordini vengono spediti entro 24-48 h e consegnati in 2-5 giorni lavorativi (Colissimo, Chronopost o punto di ritiro Mondial Relay). La consegna è gratuita oltre un certo importo e a partire da 2 pneumatici.",
  "home.faq3q": "Posso restituire un ricambio che non va bene?",
  "home.faq3a": "Sì, ha 14 giorni dal ricevimento per restituire un ricambio nuovo, non montato e nella confezione originale. Il rimborso avviene entro 14 giorni dal ricevimento del pacco.",
  "home.faq4q": "I ricambi sono garantiti?",
  "home.faq4a": "Tutti i ricambi venduti su OTOPIECES.COM sono nuovi, di grandi produttori (Bosch, Mann-Filter, TRW, Febi…) e coperti dalla garanzia legale di conformità di 2 anni.",
  "home.faq5q": "Quali metodi di pagamento accettate?",
  "home.faq5a": "Il pagamento avviene con carta (Visa, Mastercard, Apple Pay, Google Pay) tramite la piattaforma sicura SumUp. I dati della Sua carta non transitano mai sui nostri server.",
  "home.faq6q": "Offrite il montaggio di ricambi o pneumatici?",
  "home.faq6a": "Sì, al momento dell'ordine può prenotare un appuntamento di montaggio in uno dei nostri centri partner. I ricambi vengono consegnati direttamente lì e montati da un professionista.",
  "acc.bankSecureNote": "I Suoi pagamenti sono elaborati in modo sicuro da SumUp. Le carte salvate qui servono solo da promemoria: vengono conservate solo le ultime 4 cifre, mai il numero completo.",
  "new.menu": "Novità",
  "new.menuHint": "{n} ricambio/i aggiunto/i questa settimana",
  "new.title": "Novità",
  "new.h1": "Novità: ricambi aggiunti negli ultimi {d} giorni",
  "new.sub": "Gli ultimi ricambi aggiunti al catalogo, ordinati per data. Selezioni il Suo veicolo per vedere solo i ricambi compatibili.",
  "new.days": "{d} giorni",
  "new.onlyVehicle": "Solo compatibili con il mio veicolo",
  "new.selectVehicle": "Selezioni il Suo veicolo per filtrare le novità compatibili",
  "new.allCats": "Tutte le categorie",
  "new.empty": "Nessuna novità per questi criteri.",
  "new.showAll": "Mostra tutte le novità",
  "new.seoTitle": "Novità ricambi auto — ultimi ricambi aggiunti",
  "new.seoDesc": "Scopra i ricambi auto aggiunti negli ultimi {d} giorni su OTOPIECES.COM: freni, filtri, motore… filtrabili per veicolo compatibile.",
  "new.badge": "Nuovo",
  "new.homeTitle": "Novità della settimana",
  "new.homeCount": "{n} ricambio/i aggiunto/i negli ultimi 7 giorni",
  "new.homeAll": "Tutte le novità",
  "new.subTitleAll": "Ricevi le novità della settimana via e-mail",
  "new.subTitleCat": "Ricevi le novità «{name}» via e-mail",
  "new.subHint": "Una sola e-mail il lunedì, solo se ci sono novità. Disiscrizione con un clic.",
  "new.subButton": "Iscrivimi",
  "new.subOk": "Iscrizione salvata",
  "new.subAlready": "Era già iscritto — iscrizione riattivata",
  "new.subError": "Iscrizione non riuscita",
  "new.subDone": "Fatto! Le novità ({scope}) saranno inviate ogni lunedì a {email}.",
  "new.subManage": "Gestisci le mie iscrizioni",
  "new.subRemoved": "Iscrizione rimossa",
  "new.subsTitle": "Novità via e-mail",
  "new.subsHint": "Ogni lunedì, i ricambi aggiunti al catalogo nelle categorie scelte.",
  "new.subsEmpty": "Nessuna iscrizione. Si iscriva dalla pagina",
  "new.subsSince": "Dal {d}",
  "new.subsLast": "ultimo invio {d}",
  "common.loadError": "Caricamento non riuscito. Controlli la connessione e riprovi.",
  "common.retry": "Riprova",
  "product.movedToCategory": "Questo prodotto non è più disponibile — ecco la categoria corrispondente.",
  "home.selectVehicle": "Selezioni il Suo veicolo",
  "home.brand": "MARCHIO",
  "home.model": "MODELLO",
  "home.year": "ANNO",
  "home.engine": "MOTORE",
  "home.chooseBrand": "Scegli un marchio",
  "home.chooseModel": "Scegli un modello",
  "home.chooseYear": "Scegli l'anno",
  "home.chooseEngine": "Scegli il motore",
  "home.search": "Cerca...",
  "home.topBrands": "Marchi più venduti",
  "home.allBrands": "Tutti i marchi",
  "home.noBrand": "Nessun marchio trovato",
  "home.noModel": "Nessun modello trovato",
  "home.selectModel": "Selezioni un modello",
  "home.selectYear": "Selezioni un anno",
  "home.noEngine": "Nessun motore disponibile",
  "home.selectedVehicle": "Veicolo selezionato",
  "home.orPlate": "o cerchi per targa",
  "home.plateLabel": "Conosce la Sua targa? La cerchi nel nostro registro",
  "home.searchBtn": "Cerca",
  "home.plateRequired": "Inserisca il Suo numero di targa",
  "home.plateNotFound": "Nessun veicolo trovato per questa targa",
  "home.identified": "Veicolo identificato:",
  "home.simulated": "(identificazione simulata)",
  "home.seeParts": "Veda i ricambi compatibili",
  "home.allVehicleBrands": "Tutti i marchi di veicoli",
  "home.notFoundCar": "Non trova la Sua auto nel catalogo?",
  "home.categoriesTitle": "Trovi ricambi nel catalogo OTOPIECES.COM",
  "home.moreParts": "Altri ricambi",
  "home.accessoriesTitle": "Essenziali per l'auto: accessori, prodotti per la pulizia e attrezzi",
  "home.allSubcategories": "Tutte le sottocategorie ({n})",
  "home.trust.return": "Resi entro 14 giorni",
  "home.trust.returnSub": "Garanzia di rimborso",
  "home.trust.payments": "Pagamenti sicuri",
  "home.trust.app": "Un'app pratica",
  "home.trust.appSub": "per acquistare ricambi auto",
  "home.trust.videos": "Video di riparazione",
  "home.trust.videosSub": "Guide video",
  "home.bestsellers": "I best seller di OTOPIECES.COM: acquistare ricambi a prezzi vantaggiosi",
  "home.compatibleParts": "Ricambi compatibili con il Suo {vehicle}",
  "home.compatibleCount": "{n} ricambi compatibili",
  "home.seeAllCompatible": "Veda tutti i ricambi compatibili",
  "home.addedToCart": "Prodotto aggiunto al carrello!",
  "home.addError": "Errore durante l'aggiunta al carrello",
  "home.carBrands": "Ricambi auto per i marchi più richiesti",
  "home.topModels": "I modelli di veicoli più consultati",
  "home.topModelsAll": "Tutti i marchi",
  "home.topModelsParts": "Ricambi compatibili",
  "home.recentVehicles": "I Suoi ultimi veicoli",
  "home.recentClear": "Cancella",
  "garage.compareTitle": "Confronta i ricambi compatibili",
  "garage.compareButton": "Confronta",
  "garage.compareThird": "+ 3° veicolo (opzionale)",
  "garage.budgetTitle": "Budget annuale di manutenzione stimato",
  "garage.budgetHint": "Stima basata sui ricambi compatibili del catalogo (parti di usura × frequenza abituale di sostituzione). Prezzo mediano, oppure «eco» = ricambio più economico.",
  "garage.budgetPerYear": " / anno",
  "garage.dropBadge": "Budget in calo di {amount}/anno dal {date}",
  "garage.historyTitle": "Andamento del budget negli ultimi 12 mesi",
  "garage.historyMedian": "Budget stimato",
  "garage.historyEco": "Budget eco",
  "garage.historyEmpty": "Lo storico inizia oggi: viene registrato un punto al giorno, la curva si formerà nelle prossime settimane.",
  "garage.historyChange": "Variazione nel periodo",
  "garage.historyAlert": "Avviso di calo inviato",
  "garage.historyRange": "Min {min} · Max {max}",
  "garage.budgetEco": "Eco:",
  "garage.budgetEcoTotal": "Budget eco:",
  "garage.budgetCoverage": "{n} voce/i stimata/e su {total}",
  "garage.budgetNoParts": "Nessun ricambio di manutenzione compatibile ancora disponibile per questo veicolo.",
  "garage.budgetPost": "Voce",
  "garage.budgetInterval": "Frequenza",
  "garage.budgetEstimated": "Prezzo mediano",
  "garage.budgetPerYearCol": "All'anno",
  "garage.budgetParts": "ricambio/i compatibile/i",
  "garage.budgetEvery": "ogni {n} anno/i",
  "garage.budgetMissing": "Non stimati (nessun ricambio compatibile):",
  "garage.budgetSeeParts": "Vedi tutti i ricambi compatibili →",
  "garage.budgetUpcoming": "Da prevedere entro 12 mesi:",
  "garage.logCol": "Libretto di manutenzione",
  "garage.logReplaced": "Sostituito il…",
  "garage.logNext": "In regola · prossimo: {d}",
  "garage.logOverdue": "Scadenza superata",
  "garage.logEdit": "modifica",
  "garage.logClear": "Cancella",
  "garage.logSaved": "Libretto di manutenzione aggiornato",
  "garage.logError": "Salvataggio impossibile",
  "garage.logTracked": "{n} voce/i registrata/e",
  "garage.logHint": "Indichi la data (e il chilometraggio) dell'ultima sostituzione: la prossima scadenza è la più vicina tra data + frequenza e km + intervallo (convertito con il Suo chilometraggio annuo). La voce esce dal budget «12 mesi» fino ad allora; il budget annuale resta invariato.",
  "garage.logKm": "km alla sostituzione",
  "garage.logKmCurrent": "km attuali del veicolo",
  "garage.logKmAt": "a {km}",
  "garage.logOrKm": "o {km}",
  "garage.logMileage": "≈ {km} oggi",
  "garage.logFromOrder": "acquistato su OTOPIECES ({d})",
  "garage.carnetPdf": "Scarica il libretto (PDF)",
  "garage.carnetPdfDone": "Libretto scaricato",
  "garage.carnetEmail": "Ricevi il libretto via e-mail",
  "garage.carnetEmailDone": "Libretto di manutenzione inviato a {email}",
  "home.seeBrands": "Veda tutti i {n} marchi",
  "home.partsFor": "Ricambi auto {brand}",
  "home.models": "{n} modelli",
  "home.manufacturers": "Offerte eccezionali sui ricambi auto dei principali produttori",
  "home.articles": "Tutto per la Sua auto: guide e consigli di esperti",
  "home.learnMore": "Scopra di più",
  "home.aboutTitle": "Ricambi auto online: tutto per la manutenzione e la riparazione della Sua auto",
  "home.about1a": "OTOPIECES.COM è il Suo negozio online di ",
  "home.about1b": "ricambi auto economici",
  "home.about1c": ": freni (dischi, pastiglie, pinze), filtri (olio, aria, abitacolo, carburante), motore, sospensioni, sterzo, illuminazione, scarico, pneumatici e cerchi. Che Lei sia un privato, un appassionato di meccanica o un'officina, qui trova il ricambio adatto al Suo veicolo al miglior prezzo.",
  "home.about2a": "Ogni codice è verificato per la ",
  "home.about2b": "compatibilità con la Sua auto",
  "home.about2c": ": selezioni marca, modello, anno e motore, oppure inserisca semplicemente la targa. Il catalogo mostra solo i ricambi compatibili, con i codici originali (OE) e le equivalenze tra produttori per confrontare e scegliere in tutta sicurezza.",
  "home.about3": "Proponiamo solo ricambi nuovi dei grandi produttori (Bosch, Mann-Filter, TRW, Febi, Valeo…), coperti dalla garanzia legale di 2 anni. Una domanda sulla scelta di un ricambio, sul montaggio o sulla compatibilità? Il nostro servizio clienti, composto da specialisti del ricambio auto, Le risponde rapidamente via chat, e-mail o telefono.",
  "home.about4a": "Ordini i Suoi ricambi in pochi clic con ",
  "home.about4b": "pagamento sicuro e consegna in 2-5 giorni",
  "home.about4c": " in Francia e in Europa (a domicilio o in punto di ritiro), reso entro 14 giorni e possibilità di prenotare il montaggio in un centro partner. OTOPIECES.COM: il ricambio al giusto prezzo, per tutti i modelli di veicolo.",
  "reviews.errRating": "Scelga una valutazione da 1 a 5 stelle",
  "reviews.errShort": "Il Suo commento è troppo breve (minimo 10 caratteri)",
  "reviews.errSend": "Errore durante l'invio della Sua recensione",
  "reviews.verifiedCount": { one: "{n} recensione verificata", other: "{n} recensioni verificate" },
  "reviews.withPhotos": { one: "{n} con foto", other: "{n} con foto" },
  "reviews.notAllowed": "Solo i clienti che hanno ordinato questo prodotto possono lasciare una recensione.",
  "reviews.yourReviewOn": "La Sua recensione su {name}",
  "reviews.invite": "Grazie per aver dedicato il tempo di condividere la Sua esperienza su questo ricambio.",
  "reviews.submit": "Pubblica la mia recensione",
  "reviews.reported": "Grazie, il nostro team verificherà questa recensione.",
  "questions.voteError": "Voto non riuscito",
  "questions.pending": "In attesa di risposta — visibile solo a Lei",
  "questions.errShort": "La Sua domanda è troppo breve (minimo 10 caratteri)",
  "questions.errName": "Inserisca il Suo nome",
  "questions.errEmail": "Inserisca un'e-mail valida per ricevere la risposta",
  "questions.yourQuestionOn": "La Sua domanda su {name}",
  "questions.send": "Invii la mia domanda",
  "tyre.summer": "Pneumatico estivo",
  "tyre.winter": "Pneumatico invernale",
  "tyre.allSeason": "Pneumatico 4 stagioni",
  "tyre.car": "Auto",
  "tyre.van": "Utilitario",
  "tyre.size": "Misura",
  "tyre.indexes": "Indice di carico / velocità",
  "tyre.season": "Stagione",
  "tyre.vehicleType": "Tipo di veicolo",
  "tyre.euLabel": "Etichetta UE",
  "tyre.fuel": "Efficienza del carburante",
  "tyre.wet": "Aderenza sul bagnato",
  "tyre.specifics": "Caratteristiche",
  "tyre.xlSpec": "XL (rinforzato)",
  "tyre.pcd": "PCD",
  "tyre.offset": "Offset (ET)",
  "tyre.centerBore": "Foro centrale",
  "tyre.material": "Materiale",
  "tyre.steel": "Acciaio",
  "tyre.aluminium": "Aluminium",
  "tyre.finish": "Finitura",
  "tyre.steelWheel": "Cerchio in acciaio",
  "tyre.aluWheel": "Cerchio in lega",
  "tyre.snowflake": "3PMSF · omologato per la legge montagna",
  "tyre.xl": "Rinforzato XL",
  "tyre.euLabelView": "Etichetta completa e PDF", "tyre.euLabelFull": "Etichetta europea", "tyre.fuelFull": "Efficienza nel consumo di carburante", "tyre.noiseFull": "Rumore di rotolamento esterno", "tyre.snowGrip": "Aderenza sulla neve (3PMSF)", "tyre.noSnowMark": "Senza marcatura neve / ghiaccio", "tyre.labelDisclaimer": "Documento informativo basato sui dati del fornitore; l'etichetta ufficiale è quella del produttore.",
  "tyre.euLabelLine1": "Etichetta",
  "tyre.euLabelLine2": "europea",
  "tyre.fuelHint": "Efficienza energetica (A = migliore)",
  "tyre.wetGrip": "Aderenza sul bagnato",
  "tyre.wetHint": "Frenata su strada bagnata (A = migliore)",
  "tyre.noiseTitle": "Rumore esterno di rotolamento",
  "tyre.noiseClass": "Rumore · classe {c}",
  "acc.dashboard": "Il mio OTOPIECES",
  "acc.garage": "La mia officina",
  "acc.maintenance": "Libretto di manutenzione",
  "acc.maintenanceTitle": "Libretto di manutenzione predittivo",
  "acc.sellerListings": "I miei annunci usato",
  "acc.sellerImport": "Importa il mio catalogo",
  "acc.sellerFeeds": "Sincronizzazione del catalogo",
  "acc.sellerOrders": "I miei ordini usato",
  "acc.seller": "Diventa venditore",
  "acc.pro": "Account professionale",
  "acc.orders": "I miei ordini",
  "acc.wishlist": "La mia lista dei desideri",
  "acc.addresses": "La mia rubrica indirizzi",
  "acc.bank": "Coordinate bancarie",
  "acc.wallet": "Il mio conto deposito",
  "acc.settings": "Impostazioni",
  "acc.compare": "Confronta",
  "acc.logout": "Disconnettersi",
  "acc.proValidated": "Account aziendale verificato",
  "acc.myAccount": "Il mio account",
  "acc.proBannerOk": "Account aziendale verificato — {company}",
  "acc.proBannerPending": "Richiesta di account aziendale in fase di verifica ({company})",
  "acc.proBannerRefused": "La sua richiesta di account aziendale è stata rifiutata",
  "acc.details": "Dettagli",
  "acc.openOrders": "{n} in corso · {spent} spesi",
  "acc.spent": "{spent} spesi",
  "acc.walletCard": "Conto deposito",
  "acc.walletHint": "Credito utilizzabile al pagamento",
  "acc.wishlistCard": "Lista dei desideri",
  "acc.wishlistHint": "pezzi seguiti",
  "acc.vehiclesHint": "veicolo/i salvato/i",
  "acc.addressesCard": "Rubrica indirizzi",
  "acc.addressesHint": "indirizzo/i",
  "acc.cards": "{n} carta/e",
  "acc.ibanYes": "IBAN salvato",
  "acc.ibanNo": "Nessun IBAN",
  "acc.lastOrder": "Ultimo ordine",
  "acc.viewOrders": "Visualizza i miei ordini",
  "acc.proCta": "È un professionista dell'automobile?",
  "acc.proCtaSub": "Richieda il suo account aziendale: prezzi IVA esclusa, fatture intestate alla sua società, badge Pro.",
  "acc.personalInfo": "Informazioni personali",
  "acc.savedAddress": "Indirizzo di spedizione salvato",
  "acc.password": "Password",
  "acc.prefs": "Preferenze di visualizzazione e notifiche",
  "acc.language": "Lingua",
  "acc.currency": "Valuta",
  "acc.orderEmails": "E-mail di tracciamento ordine (conferma, spedizione)",
  "acc.marketing": "Offerte e promozioni personalizzate",
  "acc.delete": "Eliminare il mio account",
  "acc.deleteInfo": "I suoi indirizzi, veicoli, liste e carte saranno eliminati. Le sue fatture restano disponibili presso il nostro servizio clienti.",
  "acc.deleteConfirm": "Eliminare definitivamente",
  "acc.currentPwd": "Password attuale *",
  "acc.newPwd": "Nuova password * (min. 8 caratteri)",
  "acc.confirmPwd": "Confermare la nuova password *",
  "acc.showPwd": "Mostra",
  "acc.hidePwd": "Nascondi",
  "acc.pwdWord": "le password",
  "acc.docLang": "Lingua dei documenti (fatture, e-mail)",
  "acc.defaultShipping": "Indirizzo di spedizione predefinito",
  "acc.defaultBilling": "Indirizzo di fatturazione predefinito",
  "acc.addressesInfo": "I suoi indirizzi sono proposti al momento dell'ordine. L'indirizzo di spedizione predefinito è compilato automaticamente.",
  "acc.bankAccount": "Conto bancario (rimborsi)",
  "acc.bankInfo": "Utilizzato solo per rimborsarla in caso di reso o annullamento.",
  "acc.saveIban": "Salvare l'IBAN",
  "acc.cardsInfo": "Per ordinare più velocemente. Il numero completo non viene mai conservato.",
  "acc.default": "Predefinito",
  "acc.remove": "Eliminare",
  "acc.save": "Salvare",
  "acc.history": "Storico delle transazioni",
  "acc.proInfo": "Officine, carrozzerie, rivenditori: benefici di prezzi IVA esclusa, fatturazione con il suo numero di partita IVA e badge Pro.",
  "acc.editInfo": "Modificare le informazioni",
  "acc.withdraw": "Revocare la mia richiesta",
  "acc.companyName": "Ragione sociale *",
  "acc.siret": "SIRET * (14 cifre)",
  "acc.vatNumber": "N. IVA intracomunitario",
  "acc.sector": "Settore di attività *",
  "acc.companyPhone": "Téléfono società",
  "acc.proof": "Prova (link Kbis / URL) — facoltativo",
  "orders.loginPrompt": "Acceda per vedere i Suoi ordini",
  "orders.login": "Accedi",
  "orders.empty": "Non ha ancora effettuato alcun ordine",
  "orders.order": "Ordine {n}",
  "orders.vehicle": "Veicolo",
  "orders.reorderVehicle": "Riacquista per la mia auto",
  "orders.reorderOk": "{n} articolo/i rimesso/i nel carrello",
  "orders.reorderPartial": "{n} articolo/i nel carrello · {s} non disponibile/i",
  "orders.reorderNone": "Nessun articolo di questo ordine è attualmente disponibile.",
  "orders.filterVehicle": "Filtra per veicolo",
  "orders.filterAll": "Tutti",
  "orders.filterNoVehicle": "Senza veicolo",
  "orders.filterEmpty": "Nessun ordine per questo veicolo.",
  "orders.cancelHint": "Ha cambiato idea? Può annullare finché l'ordine non è in preparazione.",
  "orders.cancel": "Annulla il mio ordine",
  "orders.cancelled": "Questo ordine è stato annullato.",
  "orders.refunded": "Questo ordine è stato rimborsato.",
  "orders.tracking": "Tracciamento del pacco — {carrier}",
  "orders.track": "Traccia il mio pacco",
  "orders.review": "Lascia una recensione",
  "orders.walletUsed": "Credito utilizzato (conto deposito)",
  "orders.paid": "pagato €{amount}",
  "orders.fittingAt": "Montaggio presso {name}",
  "orders.fitTyres": { one: "{n} pneumatico", other: "{n} pneumatici" },
  "orders.fitRequested": "Fascia oraria richiesta: {d} — in attesa di conferma da parte del centro.",
  "orders.fitConfirmed": "Appuntamento confermato: {d}",
  "orders.fitContact": "Il centro La contatterà per fissare l'appuntamento{p}.",
  "orders.fitReview": "Valuti questo centro di montaggio",
  "orders.fitRating": "La Sua valutazione del centro: {r}/5 — grazie!",
  "appt.locked": "Appuntamento tra meno di {h} h: per modificarlo, contatti il centro{p}.",
  "appt.actionFailed": "Azione non possibile",
  "appt.moved": "Appuntamento spostato — il centro deve confermare il nuovo orario",
  "appt.requested": "Fascia oraria richiesta — il centro deve confermarla",
  "appt.confirmCancel": "Annullare questo appuntamento? Il montaggio è ancora previsto; il centro Le proporrà un'altra data.",
  "appt.cancelled": "Appuntamento annullato — il centro è stato avvisato",
  "appt.confirmCancelService": "Annullare definitivamente il montaggio presso {name}?\n\nL'importo del montaggio (€{a}) Le sarà rimborsato sotto forma di conto deposito sul Suo account e verrà generata una nota di credito PDF. I Suoi pneumatici restano ordinati.",
  "appt.serviceCancelled": "Montaggio annullato — €{a} accreditati sul Suo conto deposito",
  "appt.move": "Spostare l'appuntamento",
  "appt.pick": "Scegliere una fascia oraria",
  "appt.cancelSlot": "Annullare la fascia oraria",
  "appt.cancelService": "Annullare il montaggio (conto deposito)",
  "appt.newSlot": "Nuova fascia oraria presso {name}",
  "appt.loadingCal": "Caricamento del calendario…",
  "appt.noCalendar": "Questo centro non ha un calendario online: indichi la data desiderata (almeno {h} h in anticipo); il centro confermerà.",
  "appt.request": "Richiedere questa fascia oraria",
  "appt.centreConfirms": "Il centro riceve un'e-mail e conferma la fascia oraria.",
  "appt.changes": { one: "{n} modifica di appuntamento — ultima: {last}", other: "{n} modifiche di appuntamento — ultima: {last}" },
  "appt.chCancelled": "annullamento",
  "appt.chReassigned": "rassegnato a {c}",
  "appt.chMoved": "spostato a {d}",
  "orders.cancelledToast": "Ordine annullato. Gli articoli sono stati rimessi in stock.",
  "orders.cancelError": "Impossibile annullare questo ordine",
  "status.En attente": "In attesa",
  "status.En cours": "In corso",
  "status.Exp\u00e9di\u00e9": "Spedito",
  "status.Livr\u00e9": "Consegnato",
  "status.Annul\u00e9e": "Annullato",
  "status.Rembours\u00e9e": "Rimborsato",
  "cat.products": "Prodotti",
  "cat.found": { one: "{n} prodotto trovato", other: "{n} prodotti trovati" },
  "cat.filterBy": "Filtra per",
  "cat.brand": "Marca",
  "cat.noBrand": "Nessuna marca",
  "cat.price": "Prezzo (€)",
  "cat.noneFilters": "Nessun prodotto corrisponde ai Suoi filtri",
  "cat.noneVehicle": "Nessun ricambio compatibile con il Suo veicolo in questa categoria",
  "cat.none": "Nessun prodotto trovato in questa categoria",
  "cat.related": "Ricerche correlate",
  "cat.filters": "Filtri",
  "search.filterCategory": "Categoria",
  "search.noneWithFilters": "Nessun risultato con questi filtri.",
  "cat.sortRelevance": "Rilevanza",
  "cat.sortPriceAsc": "Prezzo: dal più basso al più alto",
  "cat.sortPriceDesc": "Prezzo: dal più alto al più basso",
  "cat.sortRating": "Più votati",
  "cat.sortDiscount": "Migliori sconti",
  "cat.sortNewest": "Novità",
  "cat.bestPriceTitle": "Mostra solo i prodotti per cui OTOPIECES è più economico di tutti i concorrenti monitorati",
  "cat.sortBy": "Ordina per",
  "cat.collapse": "Riduci",
  "cat.moreSubs": "Vedi le altre {n} sottocategorie",
  "cat.yourVehicle": "Il Suo veicolo",
  "cat.onlyCompatible": "Mostra solo i ricambi compatibili",
  "cat.allParts": "Mostra tutti i ricambi",
  "cat.change": "Cambia",
  "acc.newsletter": "Ricevere le offerte e la newsletter OTOPIECES.COM",
  "acc.changePwd": "Cambia password",
  "acc.deleteOpen": "Desidero eliminare il mio account",
  "acc.confirmYourPwd": "Confermi la Sua password",
  "acc.addrLabel": "Etichetta (Casa, Officina…)",
  "acc.addrLabelPh": "Casa",
  "acc.myAddresses": "I miei indirizzi ({n}/10)",
  "acc.addAddress": "Aggiungi un indirizzo",
  "acc.noAddress": "Nessun indirizzo salvato per ora.",
  "acc.shipDefault": "Spedizione predefinita",
  "acc.setShipping": "Imposta per la spedizione",
  "acc.billDefault": "Fatturazione predefinita",
  "acc.setBilling": "Imposta per la fatturazione",
  "acc.holder": "Titolare del conto *",
  "acc.savedCards": "Carte salvate ({n}/5)",
  "acc.addCard": "Aggiungi una carta",
  "acc.noCard": "Nessuna carta salvata.",
  "acc.month": "Mese *",
  "acc.year": "Anno *",
  "acc.txCredit": "Credito aggiunto",
  "acc.txDebit": "Addebito",
  "acc.txOrder": "Usato sull'ordine",
  "acc.txRefund": "Rimborso in conto deposito",
  "acc.balance": "Saldo disponibile",
  "acc.walletUsage": "Utilizzabile automaticamente al momento del pagamento (casella «Usa il mio conto deposito»).",
  "acc.noTx": "Nessun movimento per ora.",
  "acc.proPending": "Richiesta in fase di verifica",
  "acc.proRefused": "Richiesta rifiutata",
  "acc.resend": "Invia nuovamente la richiesta",
  "acc.requestPro": "Richiedere un conto professionale",
  "cat.showResults": "Mostra {n} prodotto/i",
  "tw.searchTyres": "Cerca pneumatici",
  "tw.tyres": "Pneumatici",
  "tw.searchWheels": "Cerca cerchi",
  "tw.wheels": "Cerchi",
  "tw.byVehicle": "Per veicolo",
  "tw.vehicle": "Veicolo",
  "tw.title": "Pneumatici, cerchi e accessori",
  "tw.counts": "{t} pneumatici, {w} cerchi",
  "tw.defaultTitle": "Pneumatici e cerchi",
  "tw.metaTitle": "Pneumatici e cerchi auto — ricerca per dimensione o per veicolo",
  "tw.metaDesc": "Trovi i Suoi pneumatici estivi, invernali e 4 stagioni per dimensione (205/55 R16) o per veicolo (dimensioni originali), e i Suoi cerchi in lega o in acciaio per interasse, offset e alesaggio centrale.",
  "tw.intro": "Cerchi i pneumatici per dimensione esatta (larghezza, altezza, diametro, indici), per veicolo (dimensioni originali del costruttore) o i cerchi per interasse, offset e alesaggio centrale. Marche premium e budget, consegna rapida, montaggio disponibile presso un centro partner.",
  "tw.oeSubtitle": "Dimensioni originali per {label}",
  "tw.accessoriesTitle": "Accessori per pneumatici e cerchi",
  "tw.accessoriesSub": "Bulloni, antifurti, sensori TPMS, catene da neve, cric e tutta l’attrezzatura intorno alla ruota.",
  "tw.articles": { one: "{n} articolo", other: "{n} articoli" },
  "tw.comingSoon": "Prossimamente",
  "tw.popularSizes": "Dimensioni più comuni",
  "tw.allSeasons": "Pneumatici per ogni stagione",
  "tw.brands": "Marchi di pneumatici e cerchi",
  "tw.guideTitle": "{k}: la guida OTOPIECES",
  "tw.about": "Informazioni: {n}",
  "tw.faqTitle": "Domande frequenti: {n}",
  "tw.summer": "Estate",
  "tw.winter": "Inverno",
  "tw.fourSeasons": "Tutte le stagioni",
  "tw.vt.voiture": "Auto",
  "tw.vt.suv": "4x4 / SUV",
  "tw.vt.utilitaire": "Furgone",
  "tw.vt.4x4": "4x4",
  "tw.quickSearch": "Ricerca rapida per dimensione",
  "tw.quickSearchEx": "— es. 205 / 55 R16 91V",
  "tw.howToRead": "Come leggo il mio pneumatico?",
  "tw.width": "Larghezza",
  "tw.height": "Altezza",
  "tw.diameter": "Diametro",
  "tw.loadIndex": "Indice di carico",
  "tw.speedIndex": "Indice di velocità",
  "tw.widthPh": "Larghezza (es. 205)",
  "tw.heightPh": "Altezza (es. 55)",
  "tw.diameterPh": "Diametro (es. R16)",
  "tw.season": "Stagione",
  "tw.advanced": "Selezionare per parametri",
  "tw.brand": "Marca",
  "tw.model": "Modello",
  "tw.allBrands": "Tutte le marche",
  "tw.modelPh": "es. Primacy, CrossClimate…",
  "tw.homologation": "Omologazione (es. MO, *, AO)",
  "tw.optional": "Opzionale",
  "tw.priceMin": "Prezzo minimo (€)",
  "tw.priceMax": "Prezzo massimo (€)",
  "tw.priceMinShort": "Prezzo min (€)",
  "tw.priceMaxShort": "Prezzo max (€)",
  "tw.runflat": "Run-flat (RunFlat)",
  "tw.runflatHint": "Le consente di percorrere ~80 km a 80 km/h dopo una foratura",
  "tw.xl": "Rinforzato (XL)",
  "tw.xlHint": "Maggiore capacità di carico",
  "tw.ms": "Fango / neve (M+S)",
  "tw.snowflake": "Aderenza su neve (3PMSF)",
  "tw.studded": "Chiodati",
  "tw.reset": "Reimposta i filtri",
  "tw.tyresInCatalog": "{n} pneumatici nel catalogo",
  "tw.wheelsInCatalog": "{n} cerchi nel catalogo",
  "tw.wheelSpecs": "Specifiche del cerchio",
  "tw.wheelSpecsEx": "— es. 7J x 17 — 5x112 — ET45 — Foro centrale 66,6 mm",
  "tw.widthJ": "Larghezza (J)",
  "tw.widthJPh": "Larghezza (es. 7J)",
  "tw.diameterInPh": "Diametro (es. 17\")",
  "tw.holes": "Numero di fori",
  "tw.holesPh": "Fori (es. 5)",
  "tw.pcd": "Interasse (PCD)",
  "tw.pcdPh": "PCD (es. 112)",
  "tw.et": "Offset (ET)",
  "tw.etPh": "Offset (es. ET45)",
  "tw.centerBore": "Foro centrale",
  "tw.centerBorePh": "Foro centrale (es. 66.6)",
  "tw.material": "Materiale",
  "tw.type": "Tipo",
  "tw.color": "Colore / finitura",
  "tw.allF": "Tutte",
  "tw.allM": "Tutti",
  "tw.wheelModelPh": "es. TZ, Ultraleggera…",
  "tw.mat.aluminium": "Alluminio",
  "tw.mat.acier": "Acciaio",
  "tw.type.alu": "Cerchio in lega",
  "tw.type.tole": "Cerchio in acciaio",
  "tw.type.ete": "Cerchio estivo",
  "tw.type.hiver": "Cerchio invernale",
  "tw.outOfStock": "Esaurito",
  "tw.leadDays": "Entro {n} giorni",
  "tw.inStock": "Disponibile · spedito entro 24 h",
  "tw.pcdShort": "PCD",
  "tw.offset": "Offset",
  "tw.bore": "Foro centrale",
  "tw.finish": "Finitura",
  "tw.perUnit": "cadauno · €{p} per 4",
  "tw.viewProduct": "Vedi prodotto",
  "tw.tyresFound": { one: "Trovato {n} pneumatico", other: "Trovati {n} pneumatici" },
  "tw.wheelsFound": { one: "Trovato {n} cerchio", other: "Trovati {n} cerchi" },
  "tw.sortPriceAsc": "Prezzo: dal più basso al più alto",
  "tw.sortPriceDesc": "Prezzo: dal più alto al più basso",
  "tw.sortRating": "Più votati",
  "tw.sortBrand": "Marca A→Z",
  "tw.noResults": "Nessun risultato per questi criteri",
  "tw.noResultsHint": "Ampliate la ricerca: rimuovete un indice o un'opzione.",
  "tw.eu.title": "Etichetta UE",
  "tw.eu.fuel": "Carburante",
  "tw.eu.wet": "Aderenza sul bagnato",
  "tw.eu.noise": "Rumore",
  "tw.eu.onlyA": "Solo A",
  "tw.eu.aTo": "A a {g}",
  "tw.eu.noiseA": "≤ 68 dB (classe A)",
  "tw.eu.noiseB": "≤ 71 dB (classe B)",
  "tw.eu.noise75": "≤ 75 dB",
  "tw.eu.snowflake": "3PMSF (Legge Montagna)",
  "tw.vs.pickAtLeast": "Scelga almeno una marca e un modello",
  "tw.vs.notFound": "Veicolo non trovato",
  "tw.vs.select": "Selezioni il Suo veicolo",
  "tw.vs.selectSub": "— mostriamo le dimensioni di pneumatici e cerchi montate di serie",
  "tw.vs.showOE": "Mostra dimensioni originali",
  "tw.vs.reset": "Reimposta",
  "tw.vs.searching": "Ricerca delle montature del costruttore per {v}… (fino a 30 s la prima volta)",
  "tw.vf.tyresAvail": { one: "{n} pneumatico disponibile", other: "{n} pneumatici disponibili" },
  "tw.vf.wheelsAvail": { one: "{n} cerchio disponibile", other: "{n} cerchi disponibili" },
  "tw.vf.none": "Nessun articolo al momento",
  "tw.vf.notFound": "Dimensioni originali non disponibili per {v}",
  "tw.vf.notFoundHint": "Legga la dimensione sul fianco del Suo pneumatico (es. 205/55 R16 91V) e utilizzi la ricerca per dimensione.",
  "tw.vf.switch": "Cerca per dimensione →",
  "tw.vf.oeFor": "Dimensioni originali del costruttore per",
  "tw.vf.aiNotice": "Dimensioni generate automaticamente dai dati del costruttore e in attesa di verifica da parte del nostro team. Prima di ordinare, confermi la dimensione indicata sul fianco del Suo pneumatico attuale.",
  "tw.vf.oeTyres": "Pneumatici originali",
  "tw.vf.oeWheels": "Cerchi originali",
  "tw.vf.thread": "Filettatura",
  "tw.vf.diameters": "Diametri",
  "tw.vf.seeTyres": "Veda i pneumatici compatibili",
  "tw.vf.seeWheels": "Voir les cercles compatibles",
  "tw.vf.in": "dans {s}",
  "tw.vc.year": "Anno",
  "tw.vc.engine": "Motorizzazione",
  "tw.vc.pickBrand": "Choisissez une marque",
  "tw.vc.pickModel": "Choisissez un modèle",
  "tw.vc.selBrand": "Selezioni una marca",
  "tw.vc.pickYear": "Choisissez l'année",
  "tw.vc.selModel": "Selezioni un modello",
  "tw.vc.allEngines": "Tutte le motorizzazioni",
  "tw.vc.selYear": "Selezioni l'anno",
  "tw.vc.hp": "CV",
  "tw.sg.title": "Come leggere la misura dei Suoi pneumatici?",
  "tw.sg.sub": "Tutto è indicato sul fianco del pneumatico. Passi il mouse o tocchi ogni parte dell'esempio",
  "tw.sg.width": "Larghezza",
  "tw.sg.widthDesc": "Larghezza del pneumatico in millimetri, misurata da fianco a fianco (qui 205 mm).",
  "tw.sg.height": "Altezza (serie)",
  "tw.sg.heightDesc": "Altezza del fianco in % della larghezza: 55% di 205 mm ≈ 113 mm. Più il numero è piccolo, più il pneumatico ha un profilo ribassato.",
  "tw.sg.radial": "Costruzione",
  "tw.sg.radialDesc": "R = costruzione radiale, lo standard su tutte le auto moderne.",
  "tw.sg.diameter": "Diametro del cerchio",
  "tw.sg.diameterDesc": "Diamètre intérieur du pneu = diamètre de votre roue, en pouces (16\" ≈ 40,6 cm).",
  "tw.sg.load": "Indice di carico",
  "tw.sg.loadDesc": "Carico massimo per pneumatico: 91 = 615 kg. Non scenda mai sotto l'indice raccomandato dal costruttore.",
  "tw.sg.speed": "Indice di velocità",
  "tw.sg.speedDesc": "Velocità massima consentita: T 190 km/h · H 210 · V 240 · W 270 · Y 300. Un pneumatico invernale può avere un indice inferiore (minimo H in Francia se ≥ velocità massima del veicolo − 1 categoria).",
  "tw.sg.where": "Dove trovarlo?",
  "tw.sg.whereText": "Sul fianco del pneumatico attuale, sull'etichetta nell'apertura della portiera del conducente, nello sportellino del carburante o nel libretto di manutenzione. Può anche usare la scheda",
  "tw.sg.whereEnd": "per trovare le misure originali.",
  "auth.loginTitle": "Accedi",
  "auth.loginSub": "Acceda al suo account OTOPIECES.COM",
  "auth.sessionExpired": "La sua sessione è scaduta. La preghiamo di accedere di nuovo.",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.emailPh": "vostra@email.com",
  "auth.passwordPh": "La sua password",
  "auth.remember": "Resta connesso",
  "auth.rememberDays": "(30 giorni)",
  "auth.forgot": "Ha dimenticato la password?",
  "auth.loggingIn": "Accesso in corso...",
  "auth.login": "Accedi",
  "auth.noAccount": "Non ha ancora un account?",
  "auth.createAccount": "Crea un account",
  "auth.emailRequired": "Email obbligatoria",
  "auth.passwordRequired": "Password obbligatoria",
  "auth.badCredentials": "Email o password errata",
  "auth.registerSub": "Crei il Suo account per seguire gli ordini e salvare i Suoi veicoli",
  "auth.firstName": "Nome",
  "auth.lastName": "Cognome",
  "auth.firstNamePh": "Mario",
  "auth.lastNamePh": "Rossi",
  "auth.emailPh2": "mario.rossi@email.com",
  "auth.phone": "Telefono (facoltativo)",
  "auth.phonePh": "+44 7700 900123",
  "auth.min8": "Minimo 8 caratteri",
  "auth.confirmPassword": "Confermi la password",
  "auth.repeatPh": "Ripeta la password",
  "auth.acceptPrefix": "Accetto le",
  "auth.terms": "condizioni generali",
  "auth.and": "e la",
  "auth.privacy": "informativa sulla privacy",
  "auth.newsletter": "Je souhaite recevoir les offres et promotions par e-mail",
  "auth.sessionHint": "Rimarrà connesso per 30 giorni su questo dispositivo.",
  "auth.creating": "Creazione account in corso...",
  "auth.createMine": "Crea il mio account",
  "auth.haveAccount": "Ha già un account?",
  "auth.firstNameRequired": "Nome richiesto",
  "auth.lastNameRequired": "Cognome richiesto",
  "auth.emailInvalid": "E-mail invalide",
  "auth.passwordsMismatch": "Le password non corrispondono",
  "auth.acceptRequired": "Deve accettare i termini",
  "auth.registerError": "Échec de l'inscription",
  "auth.forgotTitle": "Password dimenticata",
  "auth.forgotMeta": "Reimposti la password del Suo account OTOPIECES.COM.",
  "auth.forgotIntro": "Inserisca il Suo indirizzo e-mail: Le invieremo un link per scegliere una nuova password.",
  "auth.checkInbox": "Controlli la Sua casella di posta",
  "auth.sentBefore": "Se esiste un account per",
  "auth.sentAfter": ", è stata appena inviata un'e-mail con un link di reimpostazione (valido per 1 ora).",
  "auth.spam": "Si ricordi di controllare la cartella spam.",
  "auth.backLogin": "Torna all'accesso",
  "auth.emailAddress": "Indirizzo e-mail",
  "auth.sendLink": "Invia il link di reimpostazione",
  "auth.emailAddressInvalid": "Indirizzo e-mail non valido",
  "auth.genericError": "Si è verificato un errore, riprovi tra poco",
  "auth.resetTitle": "Nuova password",
  "auth.resetMeta": "Scelga una nuova password per il Suo account OTOPIECES.COM.",
  "auth.account": "Account:",
  "auth.linkIncomplete": "Link incompleto: apra il link ricevuto via e-mail.",
  "auth.linkInvalid": "Link non valido o scaduto",
  "auth.requestNew": "Richiedi un nuovo link",
  "auth.changed": "Password modificata!",
  "auth.redirecting": "Ora è connesso. Reindirizzamento in corso…",
  "auth.newPassword": "Nuova password",
  "auth.min8Ph": "Almeno 8 caratteri",
  "auth.saveNew": "Salva la nuova password",
  "auth.min8Long": "La password deve contenere almeno 8 caratteri",
  "auth.cannotChange": "Impossibile modificare la password",
  "auth.tooMany": "Troppe richieste. Riprovi tra 15 minuti.",
  "auth.linkInvalidDetail": "Questo link di reimpostazione non è valido o è scaduto. Richieda un nuovo link.",
  "common.loading": "Caricamento…",
  "search.parts": "Ricambi {b}",
  "search.metaQuery": "Ricerca « {q} »",
  "search.metaDefault": "Ricerca di ricambi",
  "search.metaDesc": "Risultati di ricerca per {q} su OTOPIECES.COM: {n} prodotto/i trovati.",
  "search.brandPage": "Vedi la pagina del marchio",
  "search.resultsFor": "Risultati per « {q} »",
  "search.title": "Ricerca",
  "search.noMatch": "Nessun prodotto corrisponde a « {q} »",
  "search.hint": "Inserisca una parola chiave, un marchio o un riferimento",
  "search.showUnfiltered": "Vedi i {n} risultati non filtrati per veicolo",
  "brands.metaTitle": "Tutti i marchi di ricambi auto dalla A alla Z",
  "brands.metaDesc": "Scopra i {n} marchi di ricambi disponibili su OTOPIECES.COM{list}. Qualità originale e garanzia di 2 anni.",
  "brands.all": "Tutti i marchi",
  "brands.countAZ": { one: "{n} marchio di ricambi, ordinato dalla A alla Z", other: "{n} marchi di ricambi, ordinati dalla A alla Z" },
  "brands.searchPh": "Cercare un marchio…",
  "brands.noMatch": "Nessun marchio corrisponde a « {q} ».",
  "search.nearTitle": "Forse cercavi… riferimenti simili",
  "search.nearVia": "tramite rif.",
  "partRequest.cta": "Richiedi questo ricambio",
  "partRequest.ctaHint": "Cerchiamo il ricambio presso i nostri fornitori e Le rispondiamo via e-mail entro 24 ore lavorative.",
  "partRequest.title": "Richiedi questo ricambio",
  "partRequest.intro": "Lasci i Suoi dati: il nostro team verifica disponibilità e prezzo e risponde via e-mail.",
  "partRequest.msgSearch": "Ricambio cercato",
  "partRequest.msgVehicle": "Veicolo",
  "partRequest.msgDetails": "Dettagli",
  "partRequest.detailsPh": "Dettagli utili: riferimento OEM, lato (sinistro/destro), anno, foto del ricambio…",
  "partRequest.submit": "Invia la richiesta",
  "partRequest.sent": "Richiesta inviata!",
  "partRequest.sentDesc": "Le abbiamo inviato una conferma di ricezione via e-mail; La ricontatteremo a breve.",
  "cat.topRated": "4 ★ e oltre",
  "cat.topRatedTitle": "Mostra solo i ricambi valutati 4/5 o più dai nostri clienti",
  "brands.sortBy": "Ordina:",
  "brands.sortAz": "A → Z",
  "brands.sortTrust": "Indice di fiducia",
  "brands.noReviews": "Nessuna recensione",
  "brands.trustHint": { one: "{n} marchio valutato dai nostri clienti — i migliori prima, poi i marchi senza recensioni in ordine alfabetico.", other: "{n} marchi valutati dai nostri clienti — i migliori prima, poi i marchi senza recensioni in ordine alfabetico." },
  "brand.notFound": "Marchio non trovato",
  "brand.metaCat": "{c} {b} — Ricambi auto",
  "brand.metaTitle": "Ricambi {b} — Catalogo e prezzi",
  "brand.metaDesc": "Tutti i ricambi {b}: {n} prodotto/i in {cats}. Qualità originale, garanzia di 2 anni, consegna rapida in Francia.",
  "brand.noProducts": "Nessun prodotto « {b} » nel nostro catalogo.",
  "brand.eyebrow": "Marchio di ricambi",
  "brand.products": { one: "{n} prodotto", other: "{n} prodotti" },
  "brand.categories": { one: "{n} categoria", other: "{n} categorie" },
  "cmp.title": "Confronto prodotti",
  "cmp.addFailed": "Impossibile aggiungere",
  "cmp.price": "Prezzo IVA inclusa",
  "cmp.oldPrice": "Prezzo barrato",
  "cmp.discount": "Sconto",
  "cmp.rating": "Valutazione clienti",
  "cmp.availability": "Disponibilità",
  "cmp.inStock": "Disponibile",
  "cmp.outOfStock": "Esaurito",
  "cmp.ref": "Riferimento",
  "cmp.subcategory": "Sottocategoria",
  "cmp.soldBy": "Venduto da",
  "cmp.pack": "lotto",
  "cmp.packs": "Confezioni",
  "cmp.warranty": "Garanzia",
  "cmp.twoYears": "2 anni",
  "cmp.compat": "Compatibilità",
  "cmp.universal": "Universale",
  "cmp.intro": "{n}/{max} prodotti · aggiunga pezzi della stessa categoria dalle schede prodotto (icona bilancia).",
  "cmp.clear": "Svuotare il comparatore",
  "cmp.empty": "Il suo comparatore è vuoto",
  "cmp.emptyHint": "Consulti il catalogo e faccia clic sull'icona bilancia per confrontare fino a {max} pezzi.",
  "cmp.browse": "Vedi i pezzi",
  "cmp.remove": "Rimuovere",
  "nf.metaTitle": "Pagina non trovata (404)",
  "nf.title": "Questo pezzo non è nel catalogo…",
  "nf.text": "La pagina richiesta è stata spostata, eliminata o non è mai esistita. Nessun panico: il percorso giusto è qui sotto.",
  "nf.searchPh": "Cercare un pezzo, un riferimento, una marca…",
  "nf.search": "Cercare",
  "nf.topCategories": "Categorie più cercate",
  "wl.guestBefore": "La Sua lista è salvata su questo dispositivo.",
  "wl.guestLogin": "Acceda",
  "wl.guestAfter": "per ritrovarla ovunque e conservarla.",
  "chat.tooShort": "Descriva la Sua richiesta in poche parole (minimo 10 caratteri).",
  "chat.failed": "Invio impossibile, riprovi.",
  "chat.open": "Contattare il servizio clienti",
  "chat.greeting": "Buongiorno! Ponga la Sua domanda, un consulente Le risponderà via e-mail.",
  "chat.another": "Inviare un altro messaggio",
  "chat.sent": "Messaggio inviato!",
  "chat.replyTime": "Risposta via e-mail entro 24 ore lavorative",
  "chat.reference": "Riferimento",
  "chat.messagePh": "Scriva il Suo messaggio...",
  "chat.emailPh": "La Sua e-mail",
  "chat.namePh": "Il Suo nome",
  "contact.sent": "Messaggio inviato",
  "contact.failed": "Invio impossibile",
  "contact.address": "Indirizzo",
  "contact.phoneWa": "Telefono / WhatsApp",
  "contact.hours": "Orari",
  "contact.metaDesc": "Contatti il servizio clienti OTOPIECES.COM: telefono, e-mail, modulo. Risposta entro 24 ore lavorative.",
  "contact.heading": "Una domanda? Le rispondiamo.",
  "contact.intro": "Compatibilità di un ricambio, tracciamento ordine, reso o fattura: il nostro team di appassionati di auto è qui per aiutarvi.",
  "contact.tracking": "Tracciamento",
  "contact.returns": "Resi",
  "contact.writeUs": "Scriveteci",
  "contact.ackSent": "Una conferma di ricezione vi è stata inviata via e-mail; vi rispondiamo entro 24 ore lavorative.",
  "contact.message": "Messaggio",
  "contact.received": "Messaggio ricevuto correttamente!",
  "contact.fullName": "Nome completo",
  "contact.newMessage": "Nuovo messaggio",
  "contact.orderNo": "N. ordine (facoltativo)",
  "contact.subject": "Oggetto",
  "contact.phone": "Telefono",
  "contact.privacyNote": "I vostri dati servono esclusivamente a gestire la vostra richiesta.",
  "contact.messagePh": "Descrivete la vostra richiesta (veicolo, riferimento del ricambio, problema riscontrato…)",
  "contact.details": "I nostri recapiti",
  "contact.send": "Invia",
  "chat.page": "Pagina:",
  "chat.send": "Invia",
  "orders.invoicePdf": "Fattura PDF",
  "cat.all": "Tutte",
  "cat.filterSubs": "Filtrare le {n} sottocategorie…",
  "cat.noSubMatch": "Nessuna sottocategoria corrisponde a « {q} »",
  "cat.otherSubs": "Altre sottocategorie {name}",
  "cat.subsubs": "Sottocategorie di {name}",
  "xsell.badge": "Complemento utile",
  "xsell.compatible": "Compatibile con il tuo veicolo",
  "xsell.addedTitle": "Aggiunto al carrello",
  "xsell.completeTitle": "Completa il tuo acquisto",
  "xsell.completeHint": "L'essenziale per l'intervento — scegli tu.",
  "xsell.continue": "Continua gli acquisti",
  "xsell.cartTitle": "L'essenziale per la tua manutenzione",
  "xsell.cartHint": "Prodotti complementari utili per i pezzi nel carrello.",
  "xsell.productTitle": "Prodotti complementari",
  "xsell.productHint": "Spesso necessari per questo intervento.",
  "cat.quickFilters": "Filtri rapidi",
  "cat.quickFiltersHint": "Scegli una sottocategoria di {name} e una marca: il pezzo giusto in due clic.",
  "cat.nProducts": { one: "{n} prodotto", other: "{n} prodotti" },
  "banner.discover": "Scoprire",
  "banner.prev": "Banner precedente",
  "banner.next": "Banner successivo",
  "banner.n": "Banner {n}",
  "about.title": "Chi siamo",
  "about.eyebrow": "Chi siamo",
  "about.heading": "{name}, il ricambio auto senza pensieri",
  "about.intro": "Nato dalla frustrazione di non trovare mai il riferimento giusto, il nostro negozio riunisce catalogo costruttore, consigli di esperti e consegna express.",
  "about.description": "{name}: lo specialista francese dei ricambi auto online. La nostra storia, i nostri valori, il nostro team.",
  "about.kpiRefs": "riferimenti in stock",
  "about.kpiMakers": "equipaggiamenti originali",
  "about.kpiBrands": "marchi di veicoli",
  "about.kpiShip": "tempo di spedizione",
  "about.kpiShipValue": "24 h",
  "about.storyTitle": "La nostra storia",
  "about.story1": "Tutto inizia in un’officina indipendente: troppo tempo perso a cercare un riferimento, troppi errori di compatibilità, troppi ritardi. Abbiamo deciso di costruire lo strumento che avremmo voluto avere: un catalogo preciso per motorizzazione, prezzi da equipaggiatore e una consegna che mantiene le promesse.",
  "about.story2": "Oggi, privati e professionisti ordinano da {name} ricambi per frenatura, filtrazione, distribuzione, sospensioni o carrozzeria dei più grandi marchi — TRW, Bosch, Brembo, Valeo, Mann-Filter, LuK… — con la garanzia del pezzo giusto, al prezzo giusto.",
  "about.promiseLabel": "La nostra promessa",
  "about.promise": "« Il ricambio giusto, consegnato rapidamente, al prezzo giusto — e una persona al telefono se necessario. »",
  "about.valuesTitle": "I nostri valori",
  "about.v1Title": "Il ricambio giusto, al primo colpo",
  "about.v1Text": "Compatibilità verificata per motorizzazione esatta e ricerca per targa: zero errori di riferimento.",
  "about.v2Title": "Il prezzo giusto",
  "about.v2Text": "Acquisto diretto presso gli equipaggiatori originali, prezzi decrescenti e tariffe professionali trasparenti.",
  "about.v3Title": "Consegna rapida, consegna corretta",
  "about.v3Text": "Spedizione entro 24 h, corrieri partner e tracciamento in tempo reale fino alla Sua porta.",
  "about.v4Title": "Responsabile",
  "about.v4Text": "Imballaggi riciclati, ricondizionamento dei resi e partner certificati.",
  "about.teamTitle": "Il team",
  "about.t1Name": "Servizio clienti",
  "about.t1Role": "Risposta entro 24 h lavorative",
  "about.t2Name": "Esperti tecnici",
  "about.t2Role": "Meccanici e carrozzieri",
  "about.t3Name": "Logistica",
  "about.t3Role": "Preparazione e spedizione",
  "about.t4Name": "Acquisti",
  "about.t4Role": "Selezione degli equipaggiatori",
  "about.joinTitle": "Desidera unirsi a noi o collaborare con noi?",
  "about.joinText": "Carriere, partnership, stampa: ne parliamo.",
  "about.careers": "Carriere",
  "about.contact": "Contattarci",
  "ret.title": "Garanzia e resi",
  "ret.description": "Reso entro 14 giorni, garanzia di 2 anni su tutti i ricambi OTOPIECES.COM. Procedura di reso in 4 fasi.",
  "ret.heading": "Soddisfatto o rimborsato, garantito 2 anni",
  "ret.intro": "Un errore di riferimento, un ricambio non adatto? Il reso è semplice e il rimborso rapido.",
  "ret.k1": "14 giorni",
  "ret.k1Text": "per cambiare idea",
  "ret.k2": "2 anni",
  "ret.k2Text": "di garanzia del costruttore",
  "ret.k3": "5 giorni",
  "ret.k3Text": "per essere rimborsato",
  "ret.stepsTitle": "Restituire un pezzo in 4 fasi",
  "ret.s1Title": "Dichiari il reso",
  "ret.s1Text": "Da « I miei ordini », annulli o ci contatti indicando il numero d'ordine e il pezzo interessato.",
  "ret.s2Title": "Imballi il pezzo",
  "ret.s2Text": "Pezzo non montato, nella sua confezione originale con la fattura. Le inviamo l'etichetta di reso.",
  "ret.s3Title": "Depositi il pacco",
  "ret.s3Text": "In ufficio postale o punto di ritiro entro 14 giorni. Il tracciamento ci informa della ricezione.",
  "ret.s4Title": "Rimborso",
  "ret.s4Text": "Entro 5 giorni dopo il controllo: sul suo metodo di pagamento o come credito immediato sul suo conto deposito.",
  "ret.coveredTitle": "Coperto dalla garanzia",
  "ret.covered1": "Difetto di fabbricazione o del materiale",
  "ret.covered2": "Pezzo non conforme al riferimento ordinato",
  "ret.covered3": "Rottura o pezzo mancante alla consegna",
  "ret.covered4": "Guasto prematuro in normali condizioni d'uso",
  "ret.notCoveredTitle": "Non coperto",
  "ret.notCovered1": "Pezzo montato, utilizzato o modificato",
  "ret.notCovered2": "Usura normale (pastiglie, dischi, filtri…)",
  "ret.notCovered3": "Montaggio non conforme alle raccomandazioni del costruttore",
  "ret.notCovered4": "Reso oltre il termine di 14 giorni o senza imballaggio originale",
  "ret.ctaTitle": "Pronto a restituire un pezzo?",
  "ret.ctaText": "Acceda ai Suoi ordini per annullare o segnalare un reso, oppure contatti il nostro servizio clienti.",
  "ret.ctaOrders": "Richiedere un reso",
  "ret.ctaContact": "Contattarci",
  "sm.title": "Mappa del sito",
  "sm.description": "Tutte le pagine di OTOPIECES.COM: categorie di ricambi, marchi, area cliente, informazioni.",
  "sm.eyebrow": "Navigazione",
  "sm.intro": "Trovi a colpo d'occhio tutte le sezioni del negozio.",
  "sm.shop": "Negozio",
  "sm.account": "Il mio account",
  "sm.help": "Aiuto",
  "sm.home": "Home",
  "sm.allParts": "Tutti i ricambi",
  "sm.brandsAZ": "Marchi dalla A alla Z",
  "sm.guides": "Guide e consigli",
  "sm.compare": "Comparatore",
  "sm.cart": "Carrello",
  "sm.myOto": "Il mio OTOPIECES",
  "sm.garage": "La mia officina",
  "sm.pro": "Account professionale",
  "sm.orders": "I miei ordini",
  "sm.wishlist": "La mia lista dei desideri",
  "sm.addresses": "Rubrica indirizzi",
  "sm.bank": "Coordinate bancarie",
  "sm.wallet": "Conto di deposito",
  "sm.settings": "Impostazioni",
  "sm.login": "Accesso",
  "sm.register": "Registrazione",
  "sm.contact": "Contatto",
  "sm.shipping": "Consegna & tracciamento",
  "sm.returns": "Garanzia & resi",
  "sm.about": "Chi siamo",
  "sm.sitemap": "Mappa del sito",
  "sm.categories": "Categorie di pezzi",
  "sm.vehicleBrands": "Marchi di veicoli",
  "sm.makers": "Produttori",
  "sm.pages": "Informazioni & pagine legali",
  "garage.title": "I miei veicoli",
  "garage.add": "Aggiungi un veicolo",
  "garage.intro": "Registri i suoi veicoli per ritrovare in un clic i pezzi compatibili. Aggiungendo la sua targa, sarà riconosciuta dalla ricerca per targa dopo la convalida da parte del nostro team.",
  "garage.selectRequired": "Selezioni marca, modello e anno",
  "garage.addedPlate": "Veicolo aggiunto — la sua targa sarà riconosciuta dalla ricerca per immatricolazione dopo la convalida da parte del nostro team",
  "garage.added": "Veicolo aggiunto",
  "garage.addError": "Errore durante l'aggiunta del veicolo",
  "garage.confirmDelete": "Eliminare {name} ?",
  "garage.deleted": "Veicolo eliminato",
  "garage.newVehicle": "Nuovo veicolo",
  "garage.brand": "Marca *",
  "garage.model": "Modello *",
  "garage.year": "Anno *",
  "garage.engine": "Motorizzazione",
  "garage.hp": "CV",
  "garage.platePh": "Targa (facoltativa) — AA-123-BB",
  "garage.labelPh": "Soprannome (facoltativo) — es. Auto di Maria",
  "garage.cancel": "Annulla",
  "garage.save": "Salva",
  "garage.empty": "Nessun veicolo registrato al momento.",
  "garage.plateValidated": "Targa convalidata",
  "garage.plateRefused": "Targa rifiutata",
  "garage.platePending": "Targa in attesa di convalida",
  "garage.useSelected": "Veicolo selezionato · Vedi i ricambi",
  "garage.use": "Usa questo veicolo",
  "garage.delete": "Elimina",
  "mb.mileage": "Chilometraggio attuale",
  "mb.mileagePh": "es. 85000",
  "mb.yearly": "Km / anno (stima)",
  "mb.save": "Salva",
  "mb.overdueKm": "superato di {n} km",
  "mb.inKm": "tra {n} km",
  "mb.overdueDays": "superato di {n} g",
  "mb.inDays": "tra {n} g",
  "mb.lastPurchase": "ultimo acquisto {date}",
  "mb.seeParts": "Vedi i ricambi",
  "mb.noVehicle1": "Aggiunga un veicolo in",
  "mb.noVehicleLink": "Il mio garage",
  "mb.noVehicle2": "per attivare il suo libretto di manutenzione predittiva.",
  "mb.estimated": "stimati oggi",
  "mb.enterMileage": "Inserisca il chilometraggio per ricevere le sue scadenze di manutenzione (distribuzione, freni, filtri…).",
  "mb.alertsTitle": "Avvisi inviati",
  "mb.see": "Vedere",
  "mb.diagTitle": "Le mie verifiche tramite foto",
  "mb.diagEmpty": "Nessuna richiesta. Il pulsante «Verificare il mio pezzo tramite foto» è disponibile nelle schede prodotto tecniche.",
  "mb.partToIdentify": "Pezzo da identificare",
  "mb.confirmed": "Riferimento confermato",
  "mb.rejected": "Non identificata",
  "mb.pending": "In attesa di convalida",
  "mb.ref": "Rif. {ref}",
  "mb.aiLead": "Pista IA: {ref} ({c} %)",
  "mb.seePart": "Vedere il pezzo",
  "promo.copyCode": "Copia il codice",
  "promo.copied": "Codice copiato!",
  "winter.myTyres": "Vedi i miei pneumatici invernali",
  "winter.seeTyres": "Vedi pneumatici invernali",
  "winter.close": "Chiudi",
  "cat.reset": "Reimposta",
  "cat.resetFilters": "Reimposta i filtri",
  "cat.guideTitle": "{kw}: la guida OTOPIECES",
  "cat.aboutTitle": "Informazioni: {name}",
  "cat.faqTitle": "Domande frequenti: {name}",
  "search.seeAll": "Vedi tutti i risultati per «{q}»",
  "product.refLabel": "Rif.",
  "content.notFound": "Pagina non trovata",
  "content.backHome": "Torna alla home",
  "content.updatedOn": "Aggiornato il {date}",
  "blog.title": "Magazine OTOPIECES.COM",
  "blog.intro": "Scopri le nostre guide pratiche, i consigli di manutenzione e i trucchi per prenderti cura del tuo veicolo.",
  "blog.searchPh": "Cerca un articolo...",
  "blog.empty": "Nessun articolo trovato",
  "blog.featured": "Articolo in evidenza",
  "blog.notFound": "Articolo non trovato",
  "blog.backToList": "Torna alle guide",
  "blog.readTime": "{time} di lettura",
  "blog.share": "Condividi:",
  "blog.related": "Articoli simili",
  "blog.popular": "Argomenti popolari",
  "blog.catOil": "Olio motore",
  "blog.catBrakes": "Freni",
  "blog.catMaintenance": "Manutenzione",
  "blog.catElectric": "Elettrico",
  "blog.nArticles": { "one": "{n} articolo", "other": "{n} articoli" },
  "blog.video1": "Come risparmiare acquistando ricambi auto?",
  "blog.video2": "Cosa fare se si accende la spia del motore",
  "blog.video3": "TOP 8 errori commessi dai proprietari di auto",
  "frev.l1": "Molto deludente",
  "frev.l2": "Deludente",
  "frev.l3": "Discreto",
  "frev.l4": "Buono",
  "frev.l5": "Eccellente",
  "frev.invalidLink": "Link non valido",
  "frev.sendError": "Invio impossibile",
  "frev.title": "La tua opinione sul centro",
  "frev.intro": "Ciao {name}, i tuoi {n} pneumatici sono stati montati presso",
  "frev.on": "il",
  "frev.order": "ordine",
  "frev.thanks": "Grazie per la tua recensione!",
  "frev.already": "Hai già valutato questo centro.",
  "frev.replyFrom": "Risposta di {author}",
  "frev.backShop": "Torna al negozio",
  "frev.question": "Come è andato il tuo appuntamento di montaggio?",
  "frev.clickStar": "Clicca su una stella",
  "frev.comment": "Il tuo commento (facoltativo)",
  "frev.commentPh": "Accoglienza, puntualità, qualità del montaggio…",
  "frev.submit": "Invia la mia recensione",
  "notif.title": "Notifiche",
  "notif.empty": "Nessuna notifica per il momento.",
  "notif.maintenanceLink": "Il mio libretto di manutenzione",
  "notif.agoMin": "{n} min fa",
  "notif.agoH": "{n} h fa",
  "notif.agoD": "{n} g fa",
  "notif.refConfirmed": "Riferimento confermato per il tuo pezzo",
  "notif.photoRequest": "La tua richiesta di verifica foto",
  "notif.fittingMoved": "Appuntamento di montaggio spostato",
  "notif.fittingConfirmed": "Appuntamento di montaggio confermato",
  "notif.fittingTomorrow": "Montaggio dei tuoi pneumatici domani",
  "notif.maintenance": "Manutenzione da prevedere: {sub} ({vehicle})",
  "notif.k.diag_auto.title": "Riferimento confermato per il suo pezzo",
  "notif.k.diag_auto.body": "Riferimento {ref} ({brand}) confermato dall'analisi della foto: {explanation}",
  "notif.k.diag_rejected.title": "La sua richiesta di verifica foto",
  "notif.k.diag_rejected.body": "{message}",
  "notif.k.diag_rejected_default.title": "La sua richiesta di verifica foto",
  "notif.k.diag_rejected_default.body": "Non siamo riusciti a identificare il pezzo nella sua foto. Riprovi con una foto più nitida o contatti il nostro servizio clienti.",
  "notif.k.diag_admin.title": "Riferimento confermato per il suo pezzo",
  "notif.k.diag_admin.body": "Il nostro team ha verificato la sua foto: il riferimento da ordinare è {ref}{brand_suffix}. {message}",
  "notif.k.maintenance_km.title": "Manutenzione da prevedere: {sub} ({vehicle})",
  "notif.k.maintenance_km.body": "In base al suo chilometraggio, il suo {sub} è in scadenza tra circa {km} km. Ecco i pezzi compatibili con la sua {vehicle}.",
  "notif.k.maintenance_now.title": "Manutenzione da prevedere: {sub} ({vehicle})",
  "notif.k.maintenance_now.body": "In base al suo chilometraggio, il suo {sub} è già in scadenza. Ecco i pezzi compatibili con la sua {vehicle}.",
  "notif.k.maintenance_days.title": "Manutenzione da prevedere: {sub} ({vehicle})",
  "notif.k.maintenance_days.body": "In base al suo chilometraggio, il suo {sub} è in scadenza tra {days} giorni. Ecco i pezzi compatibili con la sua {vehicle}.",
  "notif.k.fit_confirmed.title": "Appuntamento di montaggio confermato",
  "notif.k.fit_confirmed.body": "{centre} ({city}) conferma il montaggio dei suoi pneumatici il {date} — ordine {order}.",
  "notif.k.fit_confirmed_requested.title": "Appuntamento di montaggio confermato",
  "notif.k.fit_confirmed_requested.body": "{centre} ({city}) conferma il montaggio dei suoi pneumatici il {date} (fascia richiesta: {requested}) — ordine {order}.",
  "notif.k.fit_moved.title": "Appuntamento di montaggio spostato",
  "notif.k.fit_moved.body": "{centre} ({city}) ha spostato il suo appuntamento al {date} — ordine {order}.",
  "notif.k.fit_reminder.title": "Montaggio dei suoi pneumatici domani",
  "notif.k.fit_reminder.body": "Promemoria: appuntamento il {date} presso {centre}, {address}.",
  "notif.k.fit_reassigned_kept.title": "Nuovo centro di montaggio",
  "notif.k.fit_reassigned_kept.body": "Il montaggio dei suoi pneumatici (ordine {order}) è ora affidato a {centre} — {address}. La sua fascia del {date} è mantenuta, in attesa di conferma del centro.",
  "notif.k.fit_reassigned_propose.title": "Nuovo centro di montaggio",
  "notif.k.fit_reassigned_propose.body": "Il montaggio dei suoi pneumatici (ordine {order}) è ora affidato a {centre} — {address}. Il centro le proporrà una data.",
  "notif.k.fit_review_reply.title": "Il centro ha risposto alla sua recensione",
  "notif.k.fit_review_reply.body": "{centre}: «{excerpt}»",
  "notif.k.fit_cancelled_credit.title": "Montaggio annullato — nota di credito emessa",
  "notif.k.fit_cancelled_credit.body": "Nota di credito {number} di {amount} accreditata sul suo conto deposito (ordine {order}).",
  "notif.k.fit_card_refund.title": "Nota di credito rimborsata sul suo metodo di pagamento",
  "notif.k.fit_card_refund.body": "La nota di credito {number} di {amount} le viene rimborsata sulla sua {method} (tempi bancari da 3 a 10 giorni).",
  "acc.notifications": "Notifiche",
  "notif.seeAll": "Vedi tutte le mie notifiche",
  "nc.kind.all": "Tutte",
  "nc.kind.fitting": "Montaggio",
  "nc.kind.diagnostic": "Diagnosi foto",
  "nc.kind.maintenance": "Manutenzione",
  "nc.unreadOnly": "Solo non lette",
  "nc.readAll": "Segna tutte come lette",
  "nc.prefs": "Preferenze",
  "nc.markRead": "Segna come letta",
  "nc.markUnread": "Segna come non letta",
  "nc.delete": "Elimina",
  "nc.empty": "Nessuna notifica per questo filtro.",
  "nc.prev": "Precedente",
  "nc.next": "Successivo",
  "nc.pageOf": "Pagina {page} / {pages}",
  "nc.prefsTitle": "Preferenze di notifica",
  "nc.prefsIntro": "Scelga, per ogni tipo di notifica, se riceverla anche via e-mail o solo nella campanella del sito.",
  "nc.emailAndBell": "E-mail + campanella",
  "nc.bellOnly": "Solo campanella",
  "nc.transactionalNote": "Le e-mail indispensabili (conferma ordine, spedizione, fattura, nota di credito, password) vengono sempre inviate.",
  "nc.ch.diagnostic": "Diagnosi foto",
  "nc.chDesc.diagnostic": "Riferimento confermato o richiesta di verifica gestita dal nostro team.",
  "nc.ch.maintenance": "Manutenzione da prevedere",
  "nc.chDesc.maintenance": "Promemoria di manutenzione calcolati in base al chilometraggio dei suoi veicoli.",
  "nc.ch.fitting": "Montaggio pneumatici",
  "nc.chDesc.fitting": "Appuntamento confermato o spostato, promemoria del giorno prima, cambio di centro.",
  "nc.ch.reviews": "Recensioni e risposte",
  "nc.chDesc.reviews": "Inviti a lasciare una recensione e risposte del centro o del nostro team alle sue recensioni.",
  "nc.ch.alerts": "Avvisi prezzo, lista desideri e domande",
  "nc.chDesc.alerts": "Calo di prezzo o ritorno in stock di un articolo seguito, risposte alle sue domande sui prodotti.",
  "ps.title": "Spazio centro partner",
  "ps.invalidLink": "Link non valido",
  "ps.savedSchedule": "Orari salvati: i clienti possono ora prenotare una fascia presso di lei.",
  "ps.saveFailed": "Salvataggio impossibile",
  "ps.savedLang": "Lingua salvata: {lang}.",
  "ps.langFailed": "Lingua non salvata",
  "ps.perTyre": "/ pneumatico",
  "ps.langHint": "Lingua di questo spazio e delle e-mail che le inviamo",
  "ps.langLabel": "Lingua",
  "ps.slotsTitle": "Le mie fasce di montaggio",
  "ps.slotsIntro": "Indichi le sue fasce di apertura per giorno: i clienti sceglieranno una fascia libera al momento dell'ordine e riceverà un'e-mail per confermarla.",
  "ps.upcomingTitle": "Prossimi appuntamenti",
  "ps.noUpcoming": "Nessun appuntamento in programma.",
  "ps.nTyres": "{n} pneumatico/i",
  "ps.toConfirm": "Da confermare",
  "ps.confirmed": "Confermato",
  "ps.confirm": "Confermare",
  "ps.edit": "Modificare",
  "ps.reviewsTitle": "Recensioni dei miei clienti",
  "ps.reviewsIntro": "Le sue risposte sono pubbliche (visibili ai clienti nella scelta del centro); il cliente viene avvisato via e-mail alla sua prima risposta.",
  "ps.noReviews": "Nessuna recensione per ora.",
  "ps.slotDuration": "Durata della fascia",
  "ps.leadDays": "Preavviso minimo (giorni, ricezione pneumatici)",
  "ps.capacity": "Veicoli per fascia",
  "ps.weekPreset": "Settimana tipo (Lun–Ven 8–12 / 14–18, Sab 9–12)",
  "ps.addRange": "fascia",
  "ps.closed": "Chiuso",
  "ps.rangeError": "Ogni fascia deve terminare dopo l'inizio.",
  "ps.saveSchedule": "Salva orari",
  "ps.ofScore": "{n} % del punteggio",
  "ps.noDelay": "Nessuna conferma misurata finora",
  "ps.delayUnderHour": "Tempo medio di conferma: meno di un'ora",
  "ps.delayAvg": "Tempo medio di conferma: {d} (100 se ≤ 12 h, 0 oltre 96 h)",
  "ps.dayShort": "g",
  "ps.relTitle": "La mia affidabilità",
  "ps.relWindow": "sugli ultimi {n} giorni, aggiornato in tempo reale",
  "ps.relIntro": "I clienti vedono prima i centri più affidabili. Un punteggio «Da monitorare» (sotto 40) su almeno {n} ordini nasconde temporaneamente il centro al momento dell'ordine.",
  "ps.visible": "Proposto ai clienti",
  "ps.hidden": "Nascosto al checkout",
  "ps.since": "dal {d}",
  "ps.relEmpty": "Nessun ordine nel periodo: il suo punteggio apparirà dopo il primo montaggio.",
  "ps.barConfirmed": "Appuntamenti confermati",
  "ps.confirmedOf": "{c} confermati su {o} ordine/i",
  "ps.pendingN": "{n} in attesa della sua conferma",
  "ps.barDelay": "Rapidità di risposta",
  "ps.barKept": "Ordini mantenuti",
  "ps.reassignedN": "{n} ordine/i riassegnati a un altro centro per mancata risposta",
  "ps.noReassigned": "Nessun ordine riassegnato — perfetto",
  "ps.pointsTitle": "Punti da migliorare",
  "ps.keepGoing": "Continui così",
  "ps.excellent": "Punteggio eccellente: appare in cima alla lista per i clienti vicini.",
  "ps.ratingLine": "Valutazione clienti: {avg}/5 su {count} recensioni · {upcoming} appuntamenti in programma.",
  "ps.histEmpty": "Storico disponibile dalla prima settimana con ordini.",
  "ps.histTitle": "Andamento del punteggio su {n} settimane",
  "ps.calTitle": "Aggiungere i miei appuntamenti al calendario",
  "ps.calIntro": "Iscriva il suo calendario a questo link: i montaggi (confermati e da confermare) compaiono automaticamente in Google Calendar, Outlook o Apple Calendar, aggiornati ogni ora.",
  "ps.copied": "Copiato",
  "ps.copyLink": "Copia link",
  "ps.subscribe": "Iscriversi (Apple / Outlook)",
  "ps.downloadIcs": "Scarica .ics",
  "ps.calGoogle": "Altri calendari (+) → «Da URL» → incolli il link.",
  "ps.calOutlook": "Aggiungi calendario → «Sottoscrivi dal Web» → incolli il link.",
  "ps.calApple": "File → Nuovo abbonamento calendario, oppure clicchi su «Iscriversi».",
  "ps.sendFailed": "Invio impossibile",
  "ps.deleteReplyConfirm": "Eliminare la sua risposta?",
  "ps.editReply": "Modifica la mia risposta",
  "ps.reply": "Rispondi",
  "ps.replyPlaceholder": "Grazie per il suo riscontro…",
  "ps.publicReply": "risposta pubblica",
  "ps.customerNotified": "il cliente viene avvisato via e-mail",
  "ps.publish": "Pubblica",
  "ps.stValidated": "Convalidato il {d}",
  "ps.stDisputed": "Contestato il {d} — in attesa di gestione",
  "ps.stResolved": "Contestazione gestita il {d}",
  "ps.actionFailed": "Azione impossibile",
  "ps.stFittings": {"one": "{count} montaggio", "other": "{count} montaggi"},
  "ps.stUpcoming": "{n} in programma",
  "ps.currentMonth": "mese in corso",
  "ps.reason": "Motivo:",
  "ps.answer": "Risposta:",
  "ps.validateConfirm": "Convalidare l'estratto di {m} ({a} IVA incl.)? La convalida è definitiva.",
  "ps.validate": "Convalida estratto",
  "ps.dispute": "Contesta",
  "ps.disputeReason": "Motivo della contestazione (montaggio mancante, importo errato…)",
  "ps.disputePlaceholder": "Es.: il montaggio dell'ordine OP-… del 12/09 non compare nell'estratto.",
  "ps.sendDispute": "Invia contestazione",
  "ps.cancel": "Annulla",
  "ps.stTitle": "I miei estratti mensili",
  "ps.stIntro": "Ogni estratto riepiloga i montaggi confermati ed eseguiti nel suo centro e l'importo (IVA incl.) da fatturarci. A fine mese, lo convalidi prima di emettere la fattura, oppure lo contesti se un montaggio o un importo è errato.",
  "ps.trend": "{d} pt dal {since}",
  "rel.excellent": "Eccellente",
  "rel.good": "Buono",
  "rel.average": "Medio",
  "rel.watch": "Da monitorare",
  "rel.noData": "Dati insufficienti",
  "rel.tip": "Conferma {c} % · Tempo di risposta {d}/100 · Riassegnazioni subite {r} ({rs}/100) · {n} ordine/i",
  "rel.detail": "conf. {c} % · tempo {d} · riass. {r}",
  "rel.weekTip": "Settimana del {d}: {s}/100 ({l}, {n} ordine/i)",
  "nc.pushEnabledBg": "Notifiche attive (anche con il sito chiuso)",
  "nc.pushTest": "Inviami una notifica di prova",
  "nc.pushTestResult": "Notifica di prova inviata a {sent} dispositivo/i su {devices}.",
  "nc.pushTestNone": "Nessun dispositivo iscritto: attivi prima le notifiche su questo dispositivo.",
  "ps.pushIntro": "Riceva un avviso su questo dispositivo, anche con lo spazio chiuso, appena un cliente prenota, sposta o annulla una fascia di montaggio, o un montaggio le viene riassegnato.",
  "nc.ch.digest": "Riepilogo settimanale",
  "nc.chDesc.digest": "Ogni lunedì mattina, un'e-mail con le sue notifiche non lette della settimana (disattivato per impostazione predefinita).",
  "nc.digestOn": "Attivo",
  "nc.digestOff": "Disattivato",
  "nc.pushTitle": "Notifiche del browser",
  "nc.pushDesc": "Riceva un avviso sul suo dispositivo appena un appuntamento di montaggio viene confermato o spostato o arriva una nuova notifica — anche con il sito chiuso (Web Push).",
  "nc.pushEnable": "Attiva notifiche del browser",
  "nc.pushEnabled": "Notifiche del browser attive",
  "nc.pushDisable": "Disattiva",
  "nc.pushDenied": "Bloccate dal browser: le autorizzi nelle impostazioni del sito.",
  "nc.pushUnsupported": "Il suo browser non supporta le notifiche.",
  "track.title": "Tracciamento della consegna",
  "track.created": "Ordine confermato",
  "track.createdDesc": "Il pagamento è stato convalidato, stiamo preparando il Suo ordine.",
  "track.processing": "In preparazione",
  "track.processingDesc": "I Suoi ricambi vengono controllati e imballati nel nostro magazzino.",
  "track.handed_over": "Pacco consegnato al corriere",
  "track.shipped": "Spedito",
  "track.shippedDesc": "Il Suo pacco è in viaggio.",
  "track.transit": "In transito",
  "track.delivered": "Consegnato",
  "track.deliveredDesc": "Il Suo pacco è stato consegnato. Buon viaggio!",
  "track.pending": "In arrivo",
  "track.eta": "Consegna stimata: {d}",
  "track.carrierLink": "Traccia su {carrier}",
  "track.noNumber": "Il numero di tracciamento Le sarà comunicato alla spedizione.",
  "track.help": "Una domanda sulla consegna? Tutte le tappe sono visualizzate qui in tempo reale.",
  "track.lastUpdate": "Ultimo aggiornamento: {d}",
  "nc.ch.cart": "Promemoria carrello",
  "nc.chDesc.cart": "Un'e-mail se lascia articoli nel carrello per 24 ore.",
  "nc.kind.delivery": "Consegna",
  "nc.ch.delivery": "Tracciamento della consegna",
  "nc.chDesc.delivery": "Nuova tappa di consegna aggiunta al Suo ordine (preparazione, transito, consegna).",
  "notif.k.delivery_step.title": "Nuova tappa di consegna — ordine {order}",
  "notif.k.delivery_step.body": "{step}{loc} Segua il Suo pacco in tempo reale in I miei ordini.",
  "notif.k.delivery_processing.title": "Il Suo ordine {order} è in preparazione",
  "notif.k.delivery_processing.body": "I Suoi ricambi vengono controllati e imballati nel nostro magazzino. Prossima tappa: la spedizione.",
  "notif.k.delivery_shipped.title": "Il Suo ordine {order} è stato spedito",
  "notif.k.delivery_shipped.body": "Il Suo pacco è in viaggio{loc}. Trova il numero di tracciamento in I miei ordini.",
  "notif.k.delivery_delivered.title": "Il Suo ordine {order} è stato consegnato",
  "notif.k.delivery_delivered.body": "Il Suo pacco è arrivato. Buon viaggio! Lasci pure una recensione sui Suoi ricambi.",
  "paylink.invalid": "Questo link di pagamento non è valido.",
  "paylink.fillCard": "Compili tutti i dati della carta.",
  "paylink.failed": "Il pagamento non è andato a buon fine.",
  "paylink.paid": "Questo ordine è già stato pagato. Grazie!",
  "paylink.expired": "Questo link di pagamento è scaduto. Ci contatti per riceverne uno nuovo.",
  "paylink.revoked": "Questo link è stato sostituito da uno nuovo: controlli la Sua ultima e-mail.",
  "paylink.cancelled": "Questo ordine è stato annullato.",
  "paylink.successTitle": "Pagamento confermato",
  "paylink.successBody": "Grazie! Il Suo ordine {o} è confermato e sarà preparato subito. Le è stata inviata un'e-mail di conferma.",
  "paylink.orderFor": "Ordine preparato per {n}",
  "paylink.toPay": "Da pagare",
  "paylink.cardTitle": "Pagamento sicuro con carta",
  "paylink.holder": "Nome del titolare",
  "paylink.payNow": "Paga {a}",
  "paylink.secure": "Connessione cifrata · I dati della carta non vengono mai memorizzati.",
  "orders.awaitingPayment": "In attesa di pagamento",
  "orders.payNow": "Paga ora",
  "checkout.sumupInfo": "Verrete reindirizzato alla pagina di pagamento sicura SumUp per inserire i dati della carta. Il vostro ordine è confermato non appena il pagamento viene accettato.",
  "checkout.walletCoversAll": "Il vostro credito copre l’intero ordine: non è necessario alcun pagamento con carta.",
  "checkout.redirecting": "Reindirizzamento al pagamento sicuro…",
  "checkout.errPayment": "L’ordine è registrato ma il pagamento non è stato possibile avviare. Riprovate oppure saldate più tardi da «I miei ordini».",
  "checkout.retryPayment": "Riprova il pagamento",
  "paylink.sumupInfo": "Verrete reindirizzato alla pagina di pagamento sicura SumUp (carta bancaria, Apple Pay, Google Pay).",
  "payret.checking": "Verifica del pagamento…",
  "payret.checkingHint": "Grazie per attendere qualche secondo, stiamo confermando il pagamento con SumUp.",
  "payret.paidTitle": "Pagamento confermato!",
  "payret.paidBody": "Grazie per il vostro ordine. Vi è stata inviata un’e-mail di conferma e il vostro ordine sarà preparato da ora.",
  "payret.failedTitle": "Pagamento non andato a buon fine",
  "payret.failedBody": "Il pagamento è stato rifiutato o annullato. Nessun importo è stato addebitato. I vostri articoli restano riservati: potete riprovare.",
  "payret.pendingTitle": "Pagamento in corso di conferma",
  "payret.pendingBody": "Non abbiamo ancora ricevuto la conferma da SumUp. Se avete pagato correttamente, il vostro ordine passerà automaticamente a «Pagato» tra pochi minuti.",
  "payret.retry": "Riprova il pagamento",
  "payret.later": "Paga più tardi",
  "payret.errorTitle": "Ordine non trovato",
  "orders.refundCard": "Ordine rimborsato sulla sua carta bancaria ({a} €) — nota di credito {n}.",
  "orders.refundCardPartial": "Rimborso parziale di {a} € effettuato sulla sua carta bancaria — nota di credito {n}.",
  "orders.creditNotePdf": "Scaricare la nota di credito (PDF)",
  "product.viewSpecs": "Le caratteristiche",
  "product.fitOk": "Compatibile con il suo veicolo",
  "product.fitUniversal": "Prodotto universale: adatto a tutti i veicoli",
  "product.fitKo": "Non adatto al suo veicolo",
  "product.fitSeeCompatible": "Vedi i ricambi compatibili",
  "product.fitChangeVehicle": "Cambia veicolo",
  "product.fitSelectHint": "Selezioni il suo veicolo per verificare la compatibilità",
  "product.fitSelectCta": "Seleziona il mio veicolo",
  "cmp.check": "Confronta",
  "cmp.checked": "Nel confronto",
  "cmp.added": "Aggiunto al confronto ({n}/{max})",
  "cmp.removed": "Rimosso dal confronto",
  "cmp.maxReached": "Può confrontare al massimo {max} articoli",
  "cmp.sameSub": "Confronti solo articoli della stessa sottocategoria",
  "cmp.open": "Confronta",
  "cmp.barTitle": "Confronto",
  "cmp.barHint": "Selezioni da 2 a {max} articoli della stessa sottocategoria",
  "cmp.barCompare": "Confronta ({n})",
  "cmp.barNeedTwo": "Aggiunga almeno 2 articoli",
  "cmp.colHeader": "Caratteristica",
  "cmp.specsTitle": "Caratteristiche tecniche",
  "cmp.diffHint": "Le righe evidenziate indicano differenze tra gli articoli.",
  "cmp.intro2": "{n}/{max} articoli · spunti « Confronta » sulle schede prodotto della stessa sottocategoria.",
  "cmp.emptyHint2": "Esplori il catalogo e spunti « Confronta » su 2 a {max} articoli della stessa sottocategoria.",
  "header.fastShipping": "Consegna rapida in 2-5 giorni",
  "product.deliverySubFast": "2-5 giorni lavorativi",
  "cart.fastShipping": "Consegna rapida in 2-5 giorni",
  "cart.freeShippingReached": "Spedizione gratuita sbloccata!",
  "header.deliveryCountry": "Paese di consegna",
  "header.freeFromShort": "gratis da {n} €",
  "sess.title": "Dispositivi connessi",
  "sess.hint": "Sessioni attualmente connesse al suo account. Disconnetta un dispositivo che non riconosce o tutti gli altri in una volta.",
  "sess.logoutEverywhere": "Disconnetti ovunque",
  "sess.logout": "Disconnetti",
  "sess.thisDevice": "Questo dispositivo",
  "sess.lastSeen": "Ultima attività",
  "sess.remembered": "accesso memorizzato",
  "sess.revoked": "Dispositivo disconnesso",
  "sess.revokedAll": "{n} dispositivo/i disconnesso/i",
  "sess.confirmAll": "Disconnettere tutti gli altri dispositivi? Resterà connesso su questo.",
  "sess.error": "Azione impossibile, riprovi",
  "sess.empty": "Nessuna sessione attiva",
  "cart.remove": "Rimuovi",
  "cat.specs": "Caratteristiche tecniche",
  "cat.specsHint": "Affini per dimensione, tipo o riferimento tecnico.",
  "cat.showMore": "Mostra altri ({n})",
  "cat.showLess": "Mostra meno",
  "garage.savedToast": "Veicolo salvato nel suo garage",
  "garage.restoredToast": "La sua {v} è stata ripristinata dal suo account",
  "garage.myVehicles": "I miei veicoli",
  "garage.manage": "Gestisci il mio garage",
  "cart.forVehicle": "Ricambi per il suo veicolo",
  "equiv.search": "Filtra…",
  "equiv.allBrands": "Tutte le marche ({n})",
  "equiv.brand": "Marca",
  "equiv.ref": "Riferimento",
  "equiv.type": "Tipo",
  "equiv.oem": "OEM costruttore",
  "equiv.alt": "Equivalenza",
  "equiv.unknownBrand": "—",
  "equiv.empty": "Nessun riferimento corrisponde a questo filtro.",
  "equiv.seeAll": "Vedere i {n} riferimenti ↓",
  "equiv.moreAlt": "+{n} equivalenze",
  "equiv.brandLink": "Vedere tutti i pezzi che fanno riferimento a {b}",
  "search.equivBrand": "Pezzi che fanno riferimento a {b}",
  "search.equivHint": "Pezzi della marca {b} e pezzi di altri produttori che indicano un riferimento equivalente {b}.",
  "cart.fitOk": "Compatibile con il suo {v}",
  "cart.fitNo": "Non confermato per il suo {v}",
  "cart.fitUniversal": "Pezzo universale · tutti i veicoli",
  "cart.fitCheck": "Verificare la scheda",
  "cart.fitWarn": { one: "{n} articolo non è confermato per il suo {v} : verifichi la compatibilità prima di ordinare.", other: "{n} articoli non sono confermati per il suo {v} : verifichi la compatibilità prima di ordinare." },
  "alt.compatible": "Alternativa compatibile con la tua {v} presso {brand}",
  "alt.samePrice": "stesso prezzo",
  "alt.morePerUnit": "+{d} € / unità",
  "cart.garageSwitch": "Cambia veicolo (il mio garage)",
  "cart.garagePick": "Scegli un veicolo dal mio garage…",
  "cart.garageHint": "La compatibilità degli articoli viene ricontrollata all'istante.",
  "notify.button": "Avvisami quando torna disponibile",
  "notify.title": "Avviso di disponibilità",
  "notify.text": "Lasci la sua e-mail: le scriveremo non appena questo ricambio sarà di nuovo disponibile (una sola volta, senza impegno).",
  "notify.emailPh": "tua@email.it",
  "notify.submit": "Avvisami",
  "notify.done": "Registrato! Riceverà un'e-mail non appena tornerà disponibile.",
  "notify.already": "È già iscritto per questo ricambio.",
  "notify.subscribed": "Avviso attivo: sarà informato via e-mail",
  "notify.cancel": "Annulla l'avviso",
  "notify.error": "Impossibile registrare la richiesta. Controlli l'indirizzo e-mail.",
  "notify.priceButton": "Avvisami se il prezzo scende",
  "notify.priceTitle": "Avviso ribasso di prezzo",
  "notify.priceText": "Lasci la sua e-mail: le scriveremo non appena il prezzo di questo ricambio scenderà (una sola volta, senza impegno).",
  "notify.priceDone": "Registrato! Riceverà un'e-mail se il prezzo scende.",
  "notify.priceAlready": "Segue già il prezzo di questo ricambio.",
  "notify.priceSubscribed": "Avviso prezzo attivo: sarà informato via e-mail",
  "acc.referral": "Invita un amico",
  "share.rewardHint": "−{p} % in regalo se un amico effettua il 1° ordine dal Suo link.",
  "share.rewardMore": "I miei premi",
  "share.rewardGuest": "Accedi: −{p} % in regalo se un amico ordina dal Suo link.",
  "share.rewardLogin": "Accedi",
  "share.refTitle": "Condividi e guadagna −{p} %",
  "share.refHow": "Ogni volta che un amico effettua il primo ordine dopo aver aperto un link da Lei condiviso (pagina, prodotto, confronto, guida), riceve via e-mail un codice personale del −{p} % valido {d} giorni. I pulsanti di condivisione del sito aggiungono automaticamente il Suo codice.",
  "share.refDisabled": "Il programma è momentaneamente sospeso.",
  "share.refWhatsapp": "Ordino qui i miei ricambi auto, dai un'occhiata:",
  "share.refTip": "Suggerimento: condivida direttamente una scheda prodotto o la Sua selezione veicolo — il link contiene già il Suo codice.",
  "share.refTotal": "Premi ottenuti",
  "share.refActive": "Codici da usare",
  "share.refRewards": "I miei codici",
  "share.refEmpty": "Nessun premio per ora: condivida i Suoi ricambi preferiti con gli amici!",
  "share.refStatus_active": "Da usare",
  "share.refStatus_used": "Usato",
  "share.refStatus_expired": "Scaduto",
  "share.refFriend": "Amico {f} · {d}",
  "share.refUntil": "fino al {d}",
  "share.tier_none": "Nessun livello ancora",
  "share.tier_bronze": "Sponsor Bronzo",
  "share.tier_silver": "Sponsor Argento",
  "share.tier_gold": "Sponsor Oro",
  "share.badgeFriends": "{n} amico/i convertito/i",
  "share.badgeNext": "Ancora {n} amico/i per diventare {tier}",
  "share.badgeMax": "Livello massimo raggiunto — grazie!",
  "share.badgeLevels": "Bronzo da 1 amico · Argento da 3 · Oro da 10",
  "acc.alerts": "I miei avvisi",
  "alerts.intro": "I suoi avvisi «Avvisami»: rientro in stock e ribasso di prezzo. Ogni avviso invia una sola e-mail, poi scompare da questa lista.",
  "alerts.active": { one: "{n} avviso attivo", other: "{n} avvisi attivi" },
  "alerts.empty": "Nessun avviso attivo. Su una scheda prodotto, clicchi «Avvisami» per sapere quando il ricambio torna disponibile o cala di prezzo.",
  "alerts.kindStock": "Di nuovo disponibile",
  "alerts.kindPrice": "Ribasso di prezzo",
  "alerts.remove": "Rimuovi",
  "alerts.removeAll": "Rimuovi tutti",
  "alerts.removed": "Avviso rimosso",
  "alerts.removedAll": "Tutti gli avvisi sono stati rimossi",
  "alerts.error": "Azione impossibile, riprovi",
  "alerts.since": "dal {d}",
  "alerts.priceWatch": "Prezzo seguito: {p} €",
  "alerts.now": "oggi",
  "alerts.backSoon": "Di nuovo in stock — e-mail in arrivo",
  "alerts.history": "Avvisi inviati (ultimi 90 giorni)",
  "alerts.sentOn": "inviato il {d}",
  "wl.priceAlerts": "Avviso prezzo su tutta la lista",
  "wl.priceAlertsHint": "Riceva un'e-mail non appena un ricambio della sua lista cala di prezzo",
  "wl.priceAlertsDone": "Avviso prezzo attivato su {n} ricambio/i ({a} già seguiti). Li trova in I miei avvisi.",
  "equiv.showMore": "Mostra di più ({n} altri riferimenti)",
  "equiv.showLess": "Mostra meno",
  "spec.equivalences": "Riferimenti equivalenti",
  "header.matchesEan": "Corrisponde al codice EAN ",
  "product.compatVerified": { one: "Compatibilità verificate tramite {n} pezzo equivalente", other: "Compatibilità verificate tramite {n} pezzi equivalenti" },
  "equiv.compareTitle": "Confrontare le equivalenze fianco a fianco",
  "equiv.compareSub": "{n} pezzi equivalenti · la colonna evidenziata è il pezzo consultato",
  "equiv.openComparator": "Aprire nel comparatore",
  "equiv.current": "Pezzo consultato",
  "equiv.colBrand": "Marca",
  "equiv.colRef": "Riferimento",
  "equiv.colPrice": "Prezzo IVA inclusa",
  "equiv.colRating": "Recensioni clienti",
  "equiv.colDelivery": "Consegna",
  "equiv.colStock": "Disponibilità",
  "equiv.colType": "Tipo",
  "equiv.cheapest": "Il meno caro",
  "equiv.bestRated": "Miglior valutato",
  "equiv.fastest": "il più rapido",
  "equiv.bestMarket": "Miglior prezzo di mercato",
  "equiv.stockLine": "{w} magazzino",
  "equiv.stockSupplier": " · +{s} fornitore",
  "equiv.outOfStock": "Esaurito",
  "equiv.supplierDelay": "Entro {n} gg (fornitore)",
  "equiv.ship24": "Spedito entro 24 h",
  "equiv.unavailable": "Non disponibile",
  "equiv.viewProduct": "Vedi la scheda",
  "equiv.hideCompare": "Nascondere il confronto",
  "equiv.showCompare": "Mostra il confronto",
  "common.close": "Chiudere",
  "scan.title": "Scansionare il codice a barre EAN",
  "scan.hint": "Inquadrare il codice a barre del pezzo o della confezione: la scheda si apre automaticamente.",
  "scan.denied": "Accesso alla fotocamera negato. Consenta la fotocamera nel browser e riprovare.",
  "scan.unavailable": "Fotocamera non disponibile su questo dispositivo. Inserire il codice EAN nella barra di ricerca.",
  "scan.found": "Pezzo trovato: {name}",
  "equiv.share": "Condividere il comparativo",
  "equiv.shareWhatsapp": "Inviare su WhatsApp",
  "equiv.shareCopy": "Copiare il link",
  "equiv.shareCopied": "Link del comparativo copiato",
  "equiv.shareText": "Può dirmi quale pezzo scegliere? Comparativo OTOPIECES : {names}",
  'cmp.shared': { one: 'Confronto condiviso — {n} pezzo', other: 'Confronto condiviso — {n} pezzi' },
  "cmp.shareTitle": "Condividere questo comparativo",
  "fb.title": "Le nostre grandi marche",
  "fb.all": "Tutte le marche",
  "fb.nav": "Marche di ricambi",
  "fb.parts": "Ricambi {b}",
  "fb.logo": "Logo {b}",
  "seo.defaultTitle": "Ricambi auto economici online — Pezzi di ricambio per tutte le marche",
  "seo.defaultDesc": "Ricambi auto al miglior prezzo su OTOPIECES.COM: freni, filtri, motore, pneumatici… Ricerca per veicolo o targa, consegna in 2-5 giorni, reso 14 giorni.",
  "vb.title": "Ricambi auto per marca di veicolo",
  "vb.meta": "Scegli la marca del tuo veicolo (Renault, Peugeot, Volkswagen, BMW, Citroën…) per trovare tutti i modelli e i ricambi compatibili.",
  "vb.crumb": "Marche di veicoli",
  "vb.intro": "Seleziona la marca della tua auto per scoprire tutti i modelli e i ricambi compatibili: freni, filtrazione, motore, pneumatici…",
  "vb.searchPh": "Cerca una marca…",
  "vb.popular": "Marche più vendute",
  "vb.all": "Tutte le marche ({n})",
  "vb.models": { "one": "{n} modello", "other": "{n} modelli" },
  "vb.brandTitle": "Ricambi {b} economici — tutti i modelli",
  "vb.brandFallback": "Marca di veicolo",
  "vb.brandH1": "Ricambi auto {b}",
  "vb.brandStats": "{m} modello/i · {p} ricambio/i compatibile/i",
  "vb.brandExcerpt": "Scegli il tuo modello {b} qui sotto, poi l'anno e la motorizzazione per mostrare solo i ricambi adatti esattamente al tuo veicolo.",
  "vb.brandEmpty": "I modelli {b} arrivano presto.",
  "vb.selectVehicle": "Seleziona un veicolo",
  "vb.topParts": "Ricambi compatibili {b} più richiesti",
  "vb.faqTitle": "Domande frequenti su {k}",
  "vb.faqParts": "i ricambi {b}",
  "vb.notFound": "Marca non trovata.",
  "vb.seeAll": "Vedi tutte le marche",
  "vm.notFound": "Modello non trovato.",
  "vm.seeBrandModels": "Vedi i modelli della marca",
  "vm.useVehicle": "Usa questo veicolo per tutto il catalogo",
  "vm.shareParts": "Condividi i ricambi compatibili",
  "vm.share": "Condividi…",
  "vm.empty": "Nessun ricambio ancora referenziato per questo modello.",
  "vm.otherModels": "Vedi gli altri modelli {b}",
  "vm.engineEmpty": "Nessun ricambio referenziato per la motorizzazione «{e}».",
  "vm.allEngines": "Vedi tutte le motorizzazioni",
  "vm.frequent": "Ricerche frequenti",
  "vm.wholeCategory": "Tutta la categoria",
  "vm.faqTitle": "Domande frequenti — ricambi {car}",
  "vm.faqFitQ": "Come essere sicuro che un ricambio sia adatto alla mia {car}?",
  "vm.faqFitA": "Ogni ricambio di questa pagina è referenziato per la {model}. Clicca sulla tua motorizzazione qui sopra (o inserisci la targa nella home): restano visibili solo i riferimenti compatibili con la tua versione.",
  "vm.faqPartsQ": "Quali ricambi si trovano per la {car}?",
  "vm.faqPartsA": "Il catalogo {model} copre attualmente: {cats}. Si arricchisce regolarmente di nuovi riferimenti.",
  "vm.faqPartsEmpty": "Il catalogo {model} è in costruzione.",
  "vm.faqDeliveryQ": "Quali sono i tempi di consegna?",
  "vm.faqDeliveryA": "I ricambi disponibili vengono spediti entro 24 h e consegnati in 2-5 giorni lavorativi. Puoi anche prenotare il montaggio in un centro partner al momento dell'ordine.",
  "vm.h1": "Ricambi auto {car}",
  "vm.intro": "Trova qui sotto tutti i ricambi verificati per la {car}. Seleziona la tua motorizzazione per mostrare solo i riferimenti che le corrispondono esattamente.",
  "vm.stats": "{e} motorizzazione/i · {p} ricambio/i compatibile/i",
  "vm.filtered": "{n} ricambio/i{e}",
  "vm.forEngine": " per {e}",
  "vm.added": "Aggiunto al carrello",
  "vm.addError": "Impossibile aggiungere al carrello",
  "pp.noVehicleTitle": "Nessun veicolo selezionato",
  "pp.noVehicleText": "Seleziona il tuo veicolo per mostrare solo i ricambi compatibili.",
  "pp.selectVehicle": "Seleziona il mio veicolo",
  "pp.backHome": "Torna alla home",
  "pp.title": "Ricambi compatibili con il tuo veicolo",
  "pp.metaTitle": "Ricambi auto compatibili con il tuo veicolo",
  "pp.metaDesc": "Seleziona il tuo veicolo (marca, modello, motorizzazione o targa) e scopri i ricambi compatibili al 100 % su OTOPIECES.COM.",
  "pp.metaTitleVehicle": "Ricambi auto {v}",
  "pp.metaDescVehicle": "Tutti i ricambi compatibili con la tua {v}: freni, filtrazione, motore, frizione… al miglior prezzo su OTOPIECES.COM.",
  "pp.categories": "Categorie",
  "br.title": "I modelli meno costosi da mantenere: classifica del budget annuale in ricambi",
  "br.h1": "I modelli meno costosi da mantenere",
  "br.crumb": "Budget manutenzione",
  "br.metaDefault": "Classifica dei modelli di veicoli per budget annuale di manutenzione stimato in base ai ricambi compatibili.",
  "br.meta": "Classifica di {n} modelli per budget annuale di manutenzione stimato (ricambi di usura compatibili × frequenza abituale). Dal più economico ({min}/anno) al più costoso ({max}/anno), manodopera esclusa.",
  "br.intro": "Per ogni modello stimiamo il budget annuale in ricambi di manutenzione a partire dai ricambi compatibili referenziati su OTOPIECES.COM: filtri, freni, candele, cinghie, ammortizzatori… moltiplicati per la loro frequenza abituale di sostituzione. Prezzo mediano dei ricambi compatibili, oppure budget «eco» con il ricambio più economico. Manodopera esclusa, tutte le motorizzazioni insieme.",
  "br.error": "Classifica al momento non disponibile.",
  "br.allBrands": "Tutte le marche ({n})",
  "br.itemStats": "{p} voci stimate su {pt} · {n} ricambi compatibili · {e} motorizzazioni",
  "br.perYear": "/ anno",
  "br.eco": "eco {v} / anno",
  "br.footnote": "Classifica ricalcolata ogni notte{d}. Stime indicative, manodopera esclusa.",
  "br.lastUpdate": " · ultimo aggiornamento {d}",
  "br.ctaQ": "Possiedi uno di questi modelli?",
  "br.ctaLink": "Aggiungilo al tuo garage",
  "br.ctaRest": " per un budget sulla tua motorizzazione esatta, un libretto di manutenzione e promemoria via e-mail.",
  "br.faqTitle": "Domande frequenti",
  "br.faq1q": "Come viene calcolato il budget di manutenzione?",
  "br.faq1a": "Consideriamo 22 voci di usura (cambio olio, filtri, pastiglie, dischi, candele, cinghie, distribuzione, ammortizzatori…). Per ogni voce, il prezzo mediano dei ricambi compatibili referenziati è diviso per la frequenza abituale di sostituzione (es. pastiglie ogni 2 anni). La somma dà il budget annuale livellato. Un modello entra in classifica solo con almeno 3 voci stimate.",
  "br.faq2q": "Qual è il modello meno costoso da mantenere?",
  "br.faq2a": "Secondo le nostre stime, {car} è in testa con circa {m} di ricambi di manutenzione all'anno a prezzo mediano ({e} in eco). La mediana dei {n} modelli classificati è di {med}/anno.",
  "br.faq3q": "Il budget include la manodopera?",
  "br.faq3a": "No: si tratta solo del budget in ricambi, tutte le motorizzazioni insieme. Aggiungi il tuo veicolo al garage per ottenere un budget sulla tua motorizzazione esatta, un libretto di manutenzione con scadenze in mesi e chilometri e promemoria via e-mail.",
  "cm.pickError": "Scegli due o tre veicoli del tuo garage da confrontare.",
  "cm.failed": "Confronto impossibile",
  "cm.title": "Confronto ricambi: {v}",
  "cm.meta": "Ricambi compatibili comuni e specifici tra {v}.",
  "cm.crumbGarage": "Il mio garage",
  "cm.crumb": "Confronto modelli",
  "cm.parts": "{n} ricambio/i",
  "cm.forThisEngine": " per questa motorizzazione",
  "cm.engines": " · {n} motorizzazione/i",
  "cm.budget": "Budget manutenzione ~{m} €/anno",
  "cm.budgetEco": "(eco {e} €)",
  "cm.cheapest": "il meno costoso da mantenere",
  "cm.budgetNone": "Budget manutenzione non stimato",
  "cm.part": "Ricambio",
  "cm.price": "Prezzo",
  "cm.exactEngine": "La mia motorizzazione esatta",
  "cm.allEngines": "Tutte le motorizzazioni del modello",
  "cm.exactHint": "Vengono confrontati solo i ricambi previsti per la motorizzazione di ciascun veicolo (o senza restrizione di motore).",
  "cm.allHint": "Vengono confrontati tutti i ricambi del modello, qualunque sia la motorizzazione.",
  "cm.all": "Tutti ({n})",
  "cm.common2": "Comuni a entrambi ({n})",
  "cm.common3": "Comuni a tutti e tre ({n})",
  "cm.partial": "Comuni a due su tre ({n})",
  "cm.only": "Solo {m} ({n})",
  "cm.onlyCol": "Solo {m}",
  "cm.common2Col": "Comuni a entrambi",
  "cm.empty": "Nessun ricambio in questa selezione.",
  "wl.title": "La mia lista dei desideri",
  "wl.empty": "Nessun ricambio salvato. Clicca sul cuore di un prodotto per ritrovarlo qui.",
  "acc.addressIntro": "I tuoi indirizzi vengono proposti al momento dell'ordine. L'indirizzo di consegna predefinito è precompilato automaticamente.",
  "acc.walletIntro": "Il tuo conto deposito viene alimentato dal nostro servizio clienti (rimborso in credito, gesto commerciale, buono).",
  "acc.prefsNote": "Il negozio è disponibile in 5 lingue e in euro; le tue preferenze vengono salvate.",
  "acc.proHt": "Prezzi mostrati IVA esclusa",
  "acc.proInvoices": "Fatture intestate alla tua azienda",
  "acc.proBadge": "Badge Pro sul tuo account",
  "va.title": "Avvisi veicolo",
  "va.intro": "Ricevi un'e-mail quando vengono aggiunti nuovi ricambi compatibili con i tuoi modelli — in riepilogo settimanale (lunedì) o a ogni aggiunta.",
  "va.empty": "Nessun avviso veicolo. Attivane uno dalla pagina di un modello.",
  "va.browse": "Sfoglia i veicoli",
  "auth.showPassword": "Mostra la password",
  "brands.kicker": "I nostri produttori",
  "brand.empty": "Nessun prodotto {b}{cat}{veh}.",
  "brand.emptyCat": " in questa categoria",
  "brand.emptyVeh": " compatibile con il tuo veicolo",
  "brand.seeUnfiltered": "Vedi i {n} prodotti non filtrati per veicolo",
  "brand.relatedSearches": "Ricerche correlate",
  "cmp.pageTitle": "Confronto prodotti",
  "common.new": "Nuovo",
  "vm.metaDesc": "Tutti i ricambi compatibili con la {car}: {cats}. {e} motorizzazione/i ({engines}…). Compatibilità verificata, consegna in 2-5 giorni.",
  "ship.title": "Consegna e tracciamento",
  "ship.metaDesc": "Tempi, spese di spedizione e corrieri di OTOPIECES.COM.",
  "ship.metaFree": "Consegna gratuita a partire da {free}.",
  "ship.eyebrow": "Consegna",
  "ship.heading": "Consegna rapida e tracciata",
  "ship.headingFree": "Consegna rapida, tracciata, gratuita a partire da {free}",
  "ship.intro": "Spedizione entro 24 h lavorative dal nostro magazzino in Francia. Scegli il corriere che preferisci.",
  "ship.fees": "Spese di spedizione",
  "ship.feesFree": "{fee} · gratuite a partire da {free}",
  "ship.avgDelay": "Tempo medio",
  "ship.avgDelayValue": "2-5 giorni lavorativi",
  "ship.insured": "Pacco assicurato",
  "ship.insuredValue": "Rottura o smarrimento rimborsati",
  "ship.how": "Come funziona?",
  "ship.s1": "Ordine confermato",
  "ship.s1Text": "Conferma immediata via e-mail con il numero d'ordine.",
  "ship.s2": "Preparazione",
  "ship.s2Text": "Ricambi controllati e imballati entro 24 h lavorative nel nostro magazzino.",
  "ship.s3": "Spedizione",
  "ship.s3Text": "E-mail con il numero di tracciamento e il link del corriere.",
  "ship.s4": "Consegna",
  "ship.s4Text": "A casa, in officina o in un punto di ritiro, a tua scelta.",
  "ship.carriers": "I nostri corrieri",
  "ship.c1Delay": "2–4 giorni lavorativi",
  "ship.c1Note": "Consegna a domicilio o in ufficio postale",
  "ship.c2Delay": "24–48 h",
  "ship.c2Note": "Espresso, ideale per le urgenze in officina",
  "ship.c3Delay": "2–3 giorni lavorativi",
  "ship.c3Note": "Pacchi voluminosi (paraurti, cofani…)",
  "ship.c4Delay": "3–5 giorni lavorativi",
  "ship.c4Note": "Ritiro in punto di consegna, economico",
  "ship.trackingKicker": "Tracciamento del pacco",
  "ship.trackingTitle": "Dov'è il mio ordine?",
  "ship.trackingText": "Trova stato, corriere e numero di tracciamento nel tuo spazio cliente.",
  "ship.trackCta": "Segui il mio ordine",
  "cat.metaSubFallback": "{sub} ({cat}) al miglior prezzo su OTOPIECES.COM: {brands}, compatibilità garantita con il tuo veicolo, consegna in 2-5 giorni, reso 14 giorni.",
  "cat.metaFallback": "Acquista i tuoi ricambi {cat} al miglior prezzo su OTOPIECES.COM: grandi marche ({brands}), compatibilità garantita con il tuo veicolo, consegna in 2-5 giorni.",
  "vg.today": "oggi",
  "vg.budgetInline": "budget manutenzione ~{m} €/anno",
  "vg.engines": "Motorizzazioni {m}",
  "vg.allN": "Tutte ({n})",
  "vg.popular": "Popolare",
  "vg.engAbbr": "{n} mot.",
  "vg.choose": "Scegli",
  "vg.parts": "Ricambi",
  "vg.seeParts": "Vedi tutti i ricambi compatibili {m}",
  "vg.allModels": "Tutti i modelli {b}",
  "vg.searchModel": "Cerca un modello…",
  "vg.gallery": "Galleria",
  "vg.list": "Elenco",
  "vg.noMatch": "Nessun modello corrisponde a «{q}».",
  "vg.popularTitle": "Modelli {b} più cercati",
  "vg.popularByUsage": "In base alle selezioni e ai garage dei nostri clienti.",
  "vg.popularByParts": "I modelli con più ricambi disponibili.",
  "vg.generations": { "one": "{n} generazione", "other": "{n} generazioni" },
  "vg.yearsEstimated": "* anni indicativi",
  "mb.title": "Budget annuale di manutenzione stimato — {car}",
  "mb.intro": "Stima basata sui {n} ricambi di usura compatibili referenziati ({p} voci su {pt}), tutte le motorizzazioni insieme: prezzo mediano, oppure «eco» con il ricambio più economico, rapportato alla frequenza abituale di sostituzione.",
  "mb.eco": "Eco: {v} / anno",
  "mb.hideDetail": "Nascondi il dettaglio",
  "mb.showDetail": "Vedi il dettaglio per voce",
  "mb.rankingLink": "Vedi la classifica dei modelli meno costosi da mantenere",
  "mb.garageLink": "Aggiungi questo veicolo al tuo garage per un budget sulla tua motorizzazione esatta e un libretto di manutenzione",
  "mb.colItem": "Voce",
  "mb.colFreq": "Frequenza",
  "mb.colEco": "Eco",
  "mb.colMedian": "Prezzo mediano",
  "mb.colYear": "All'anno",
  "mb.every": { "one": "ogni anno", "other": "ogni {n} anni" },
  "mb.missing": "Non stimati (nessun ricambio compatibile per ora): {list}",
  "val.cta": "Avvisami dei nuovi ricambi",
  "val.activated": "Avviso attivato ({f}{e})!",
  "val.weeklyShort": "riepilogo settimanale",
  "val.instantShort": "a ogni aggiunta",
  "val.already": "Avviso già attivo",
  "val.active": "Avviso nuovi ricambi attivo",
  "val.disable": "Disattiva",
  "val.formTitle": "Ricevi un'e-mail quando vengono aggiunti nuovi ricambi compatibili",
  "val.emailPh": "tua@email.it",
  "val.enable": "Attiva",
  "val.onlyEngine": "Solo la mia motorizzazione",
  "val.weekly": "Riepilogo settimanale (lunedì)",
  "val.instant": "A ogni aggiunta",
  "val.error": "Impossibile attivare l'avviso, controlla l'indirizzo e-mail.",
  "val.notifyWhenAdded": "Avvisami appena viene aggiunto un ricambio",
  "gar.alertEnabledNote": "Avviso «nuovi ricambi» attivato (riepilogo settimanale).",
  "gar.alertOptIn": "Avvisami via e-mail dei nuovi ricambi compatibili con questo veicolo",
  "gar.alertOptInHint": "(riepilogo settimanale, modificabile in I miei avvisi)",
  "vb.brandMeta": "Ricambi {b}: {m} modelli ({fams}…) e {p} ricambi compatibili al miglior prezzo. Freni, filtrazione, motore, pneumatici.",
  "vb.partsInCat": "Ricambi {c} {b} ({n})",
  "vb.allParts": "Tutti i ricambi",
  "vb.noPartsInCat": "Nessun ricambio di questa categoria per questa marca al momento.",
  "vb.modelFilter": "Filtra per modello",
  "vb.allModelsOpt": "Tutti i modelli",
  "vb.partsForModel": "Ricambi compatibili con {b} ({n})",
  "vb.modelPage": "Scheda del modello",
  "vb.noPartsForModel": "Nessun ricambio di questa categoria compatibile con questo modello al momento.",
  "vb.modelsWithParts": "Modelli con ricambi referenziati",
  "vb.modelsOther": "Altri modelli",
  "vb.engineFilter": "Filtra per motorizzazione",
  "vb.allEnginesOpt": "Tutte le motorizzazioni",
  "fuel.essence": "Benzina", "fuel.diesel": "Diesel", "fuel.hybride": "Ibrido", "fuel.essence/électrique": "Ibrido benzina", "fuel.diesel/électrique": "Ibrido diesel", "fuel.électrique": "Elettrico", "fuel.gpl": "GPL",
  "fuel.essence/gpl": "Benzina / GPL", "fuel.essence/éthanol": "Benzina / etanolo",
  "vb.garageAdd": "Aggiungi al mio garage",
  "vb.garageSee": "Nel mio garage — vedi",
  "vb.garageAdded": "{car} aggiunto al tuo garage.",
  "vb.garageAlready": "Questo veicolo è già nel tuo garage.",
  "vb.garageError": "Impossibile aggiungere questo veicolo.",
  "vb.garageLoginHint": "Accedi per salvare questo veicolo nel tuo garage",
  "vb.alertCta": "Avvisami dei nuovi ricambi {m}",
  "vb.share": "Condividi questa selezione",
  "vb.shareText": "Ricambi compatibili {sel} su OTOPIECES.COM",
  "vb.shareCopied": "Link della selezione copiato negli appunti.",
  "vb.shareCopiedShort": "Link copiato",
  "vb.shareCopyManual": "Copia questo link:",
  "vb.shareCheapest": "I 3 ricambi più economici:",
  "vb.shareWhatsappHint": "Invia la selezione e i 3 ricambi più economici via WhatsApp",
  "fuelR.title": "Alimentazione",
  "fuelR.all": "Tutte le motorizzazioni",
  "fuelR.essence": "Benzina",
  "fuelR.diesel": "Diesel",
  "fuelR.electrique": "100 % elettrico",
  "fuelR.reserved": "Solo per motori:",
  "fuelR.vehicleHint": "Ordine per rilevanza: prima i ricambi {e} del suo veicolo",
  "product.fitFuelKo": "Solo per motori {e} — il suo veicolo è {ve}",
  "cart.fitFuel": "Solo {e} · la sua {v} è {ve}",
  "garage.additivesTitle": "Additivi consigliati",
  "garage.additivesHint": "Additivi e detergenti adatti all'alimentazione di ciascuno dei suoi veicoli.",
  "garage.additivesEmpty": "Nessun additivo compatibile per ora.",
  "garage.additiveHint": "Non dimentichi l'additivo:",
  "packEss.onAdditive": "sull'additivo",
  "packEss.desc": "Questo olio + un additivo carburante benzina: -{p} % sull'additivo, sconto applicato automaticamente al pagamento.",
  "packEss.total": "Il lotto:",
  "packEss.add": "Aggiungi il lotto al carrello",
  "packEss.done": "Lotto aggiunto",
  "packEss.added": "Lotto aggiunto al carrello — codice {c} applicato",
  "packEss.addedLogin": "Lotto aggiunto — lo sconto {c} sarà applicato al pagamento dopo l'accesso",
  "packEss.code": "Sconto con il codice {c}, valido con un olio motore nel carrello.",
  "packEss.titleDiesel": "Pack manutenzione diesel",
  "packEss.descDiesel": "Questo olio + un additivo diesel o pulitore FAP: -{p} % sull'additivo, sconto applicato automaticamente al pagamento.",
  "packEss.cartDesc": "Il suo olio motore è solo nel carrello: completi il lotto con l'additivo adatto, -{p} % su di esso.",
  "packEss.cartAdd": "Aggiungi l'additivo al lotto (-{p} %)",
  "packEss.title": "Pack manutenzione benzina",
};

export default it;
